<template>
    <div v-loading="loading">
        <div class="flex borderB padB5">
            <el-button v-if="i_checkstate==1&&i_invoiceType=='1'&&reverseId==0" size="small" type="danger" @click="spillover">{{$t('invoiceEntry_write-off_in_red')}}
            </el-button>
        </div>
        <div>
            <div class="pad15_25">
                <div class="flex w100 marT10">
                    <div class="flex w33 alc">
                        <span class="marr4 font14">{{$t('invoiceEntry_billing_type')}}</span>
                        <el-select :disabled="disinput" @change="changeData($event,'fpt')"
                                   @clear="clearsearch('fpt')" class="marr4 Input" v-model="vc_type" size="mini" clearable
                                   filterable :placeholder="$t('invoiceEntry_please_select_the_billing_type')">
                            <el-option
                                    v-for="item in fpType"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="flex w33 alc">
                        <span class="marr4 font14">{{$t('invoiceEntry_invoice_type')}}</span>
                        <el-select :disabled="i_issd==1?true:disinput"
                                   @change="changeData($event,'fplx')" @clear="clearsearch('fplx')" class="marr4 Input"
                                   v-model="vc_fptype" size="mini" clearable filterable :placeholder="$t('invoiceEntry_please_select_the_invoice_type')">
                            <el-option
                                    v-for="item in fplxData"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="flex w33 alc">
                        <span class="marr4 font14">{{$t('invoiceEntry_invoice_time')}}</span>
                        <!--<span class="font14">{{formData.dt_fptime}}</span>-->
                        <!---->
                        <el-date-picker
                                class="Input"
                                :disabled="disinput"
                                v-model="formData.dt_fptime"
                                size="mini"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                type="date"
                                :placeholder="$t('form_select_date')"
                                :picker-options="pickerOptions">
                        </el-date-picker>
                    </div>
                    <div class="flex w33 alc">
                        <span class="marr4 font14">{{$t('invoiceEntry_jztime')}}</span>
                        <el-date-picker
                                @change="changedate"
                                class="Input"
                                :disabled="i_checkstate!='0'&&i_invoiceType==1?true:disabled"
                                v-model="formData.dt_cwtime"
                                size="mini"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                type="date"
                                :placeholder="$t('form_select_date')"
                                :picker-options="pickerOptions">
                        </el-date-picker>
                    </div>
                </div>
                <div class="flex w100 marT10">
                    <div class="flex w33 alc">
                        <span class="marr4 font14">{{$t('invoiceEntry_issuer')}}</span>
                        <el-select :disabled="disinput" remote :remote-method="remoteMethodkp"
                                   @change="changeData($event,'kpf')" @clear="clearsearch('kpf')" class="marr4 Input"
                                   v-model="vc_kpkhname" size="mini" clearable filterable :placeholder="$t('invoiceEntry_please_select_the_invoicing_party')">
                            <el-option
                                    v-for="item in kpfData"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="flex w33 alc">
                        <span class="marr4 font14">{{$t('invoiceEntry_purchaser')}}</span>
                        <el-select :disabled="disinput" @change="changeData($event,'gs')"
                                   @clear="clearsearch('gs')" class="marr4 Input" v-model="companyName" size="mini" clearable
                                   filterable :placeholder="$t('invoiceEntry_please_select_the_ticketing_company')">
                            <el-option
                                    v-for="item in compsData"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="flex w33 alc" >
                        <template v-if="i_id==0">
                            <span class="marr4 font14">{{$t('invoiceEntry_invoice_code')}}</span>
                            <el-input @change="resetnote" disabled class="marr4 Input"
                                      v-model="formData.vc_fpcode" :placeholder="$t('invoiceEntry_please_select_invoice_number')" clearable size="mini"></el-input>

                        </template>
                        </div>
                    <!--<div class="flex w33 alc" >
                        &lt;!&ndash;<ul>
                            <li v-for="(oneimg,index) in filesfp" :key="index">
                                <a :href="file_root+oneimg.vc_mainfile_newname" target="_blank">
                                    {{oneimg.vc_filename}}
                                </a>
                            </li>
                        </ul>
                        <span v-if="isred" class="marr4 font14">{{'（关联发票金额）'+spillfppay}}</span>&ndash;&gt;
                    </div>-->
                    <div class="flex w33 alc">
                        <span class="marr4 font14">{{$t('invoiceEntry_attachment')}}</span>
                        <template v-if='filesfp.length==0'>

                            <el-button v-if="i_id==0||(i_id!=0&&i_invoiceType==2)" size="mini" type="text" style="color:#fa5050" @click="opencodes">
                                +{{$t('invoiceEntry_related_invoice')}}
                            </el-button>
                        </template>
                        <template v-else>
                            <ul>
                                <li v-for="(oneimg,index) in filesfp" :key="index">
                                    <a :href="file_root+oneimg.vc_mainfile_newname" target="_blank">
                                        {{oneimg.vc_filename}}
                                    </a>
                                    <i      v-if="i_id==0"
                                            class="el-icon-delete"
                                            @click="delfil(oneimg,index)"
                                    ></i>
                                </li>

                            </ul>
                        </template>

                    </div>
                </div>
                <div class="flex w100 marT10" v-if="isdk==1">
                    <div class="flex w33 alc">
                        <span class="marr4 font14">{{$t('invoiceEntry_is_it_a_proxy_for_opening')}}</span>
                        <el-radio-group v-model="i_isagent" @change="choosedk" :disabled="disinput2">
                            <el-radio :label="1">{{$t('form_correct')}}</el-radio>
                            <el-radio :label="0">{{$t('form_deny')}}</el-radio>
                        </el-radio-group>
                    </div>
                    <div class="flex w33 alc" v-if="i_isagent==1&&isdk==1">
                        <span class="marr4 font14">{{$t('invoiceEntry_seller')}}</span>
                        <el-select @blur="yanzheng" :disabled="disinput2" @change="changeData($event,'xs')"
                                   @clear="clearsearch('xs')" class="marr4" v-model="xsComname" size="mini" clearable
                                   filterable :placeholder="$t('invoiceEntry_please_select_a_sales_company')">
                            <el-option
                                    v-for="item in xsData"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <!--<div class="flex w100 marT10 alc" v-if="i_flag==1&&i_isfrom==0">
                    <span class="marr4 font14">币种</span>
                    <el-select  style="width: 190px" :disabled="disinput" @change="changeData($event,'bz')" @clear="clearsearch('bz')" class="marr4" v-model="vc_bzname" size="mini" clearable filterable placeholder="请选择币种">
                        <el-option
                                v-for="item in bzData"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.i_id">
                        </el-option>
                    </el-select>
                </div>-->
                <!--v-if="i_origin_khtype==2"  max-height: 48px;line-height: 48px-->
                <!--<div class="flex w100 marT10 alc" style="height:100%;">
                    <span class="marr4 font14">{{$t('invoiceEntry_select_order')}}</span>
                    <div class="w100 border pad10"  @click="goOrder">{{orderWs}}</div>
                </div>-->
               <!-- <div class="flex w100 alc martb5" v-if="i_id!=0&&i_fytype!=1">
                    <span class="marr4 font14" @click="goconnect">查看关联订单</span>
                </div>-->
                <!--<el-table
                        v-if="showTable"
                        ref="table"
                        size="mini"
                        border
                        :data="tableData"
                        :height="tableHeight"
                        style="width: 100%"
                        class="marT10"
                        :header-cell-style="{background:'#eef1f6',color:'#000'}"
                >
                    <el-table-column
                            type="index"
                            label=""
                            show-overflow-tooltip
                            width="35">
                    </el-table-column>
                    <el-table-column
                            v-if="i_isfrom==1"
                            prop="vc_fppzname"
                            :label="$t('invoiceEntry_invoice_item_name')"
                            show-overflow-tooltip
                            min-width="250">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark"
                                        :content="scope.row.vc_fppzname+' /'+$t('invoiceEntry_specification_model')+'：'+scope.row.vc_fpbzstyle+' /'+$t('form_unit')+'：'+scope.row.vc_fpunit+' /'+$t('form_quantity')+'：'+scope.row.f_fpnum+' /'+$t('form_unit_price')+'：'+scope.row.f_fpprice+' /'+$t('form_amount')+'：'+scope.row.f_fppay_ws+' /'+$t('invoiceEntry_tax_amount')+'：'+scope.row.f_fppay_zzs"
                                        placement="top">
                                <div class="fppm">{{scope.row.vc_fppzname+' /'+$t('invoiceEntry_specification_model')+'：'+scope.row.vc_fpbzstyle+' /'+$t('form_unit')+'：'+scope.row.vc_fpunit+' /'+$t('form_quantity')+'：'+scope.row.f_fpnum+' /'+$t('form_unit_price')+'：'+scope.row.f_fpprice+' /'+$t('form_amount')+'：'+scope.row.f_fppay_ws+' /'+$t('invoiceEntry_tax_amount')+'：'+scope.row.f_fppay_zzs}}
                                </div>
                            </el-tooltip>
                            &lt;!&ndash;<span class="fppm">{{scope.row.vc_fppzname+' /'+$t('invoiceEntry_specification_model')+'：'+scope.row.vc_fpbzstyle+' /'+$t('form_unit')+'：'+scope.row.vc_fpunit+' /'+$t('form_quantity')+'：'+scope.row.f_fpnum+' /'+$t('form_unit_price')+'：'+scope.row.f_fpprice+' /'+$t('form_amount')+'：'+scope.row.f_fppay_ws+' /'+$t('invoiceEntry_tax_amount')+'：'+scope.row.f_fppay_zzs}}</span>&ndash;&gt;
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="vc_pzname"
                            :label="$t('invoiceEntry_project_name')"
                            show-overflow-tooltip
                            min-width="110">
                        <template slot-scope="scope">
                            <el-popover
                                    class="pop"
                                    :tabindex="scope.$index"
                                    :id="scope.$index+'pop'"
                                    placement="bottom-end"
                                    width="1000"
                                    trigger="manual"
                                    v-model="scope.row.visible"
                                    style="z-index: 9999">
                                &lt;!&ndash;<template>
                                    <product-details v-if="scope.row.visible==true&&i_fytype!=1" :productDetails="productDetails" @closePop="closePop(scope.$index)" @transValue="transValue"></product-details>
                                    <product-detailsnew ref="varietySelector" v-if="scope.row.visible==true&&i_fytype==1"
                                                        :varieties="varieties"
                                                        :invoices="invoices"
                                                        @confirm="onVarietyConfirm" :productDetails="productDetails" @closePop="closePop(scope.$index)" @transValue="transValue"></product-detailsnew>
                                </template>&ndash;&gt;
                                <span v-if="i_fytype!=1" slot="reference"
                                      @click="goOrder(tableData,scope.$index,scope.row)"
                                      class="blue">{{scope.row.i_type==0?'-':(scope.row.vc_pzname==''?'['+$t('invoiceEntry_please_select_the_variety')+']':scope.row.vc_pzname) }}</span>
                                &lt;!&ndash;+' '+scope.row.vc_cd+scope.row.vc_gykh+scope.row.vc_bzstyle&ndash;&gt;
                                <span v-else slot="reference" @click="goOrder(tableData,scope.$index,scope.row)"
                                      class='blue'>{{scope.row.vc_fppzname}}</span>
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column
                            v-if="i_isfrom==1&&i_type==2&&i_id==0"
                            prop="vc_bzstyle"
                            :label="$t('invoiceEntry_split_components')"
                            show-overflow-tooltip
                            width="85">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.i_type==1" class="popaddbtn"
                                       @click="splitdata(scope.row,scope.$index)"><i class="el-icon-plus backgw"></i>
                            </el-button>
                        </template>
                    </el-table-column>
                    &lt;!&ndash;<el-table-column
                            v-if="i_fytype!=1"
                            prop="vc_bzstyle"
                            :label="$t('invoiceEntry_specification_model')"
                            show-overflow-tooltip
                            width="80">
                    </el-table-column>&ndash;&gt;
                    <el-table-column
                            v-if="i_isfrom==1&&i_fytype!=1"
                            prop="vc_fpunit"
                            :label="$t('invoiceEntry_invoice_unit')"
                            show-overflow-tooltip
                            width="116">
                    </el-table-column>
                    <el-table-column
                            v-if="i_isfrom==1&&i_fytype!=1"
                            prop="f_bcfpnum"
                            :label="$t('invoiceEntry_invoice_quantity')"
                            show-overflow-tooltip
                            width="150"
                            align="right">
                        &lt;!&ndash;<template slot-scope="scope">
                            <span v-if="scope.row.f_pay_ws<0" >{{scope.row.f_bcfpnum}}</span>
                            <el-input-number v-else :disabled="scope.row.i_type==0?true:isred"
                                             @change="inbcfnum(tableData,scope.$index,scope.row)" :controls="false"
                                             :precision="$setPrecision.quantityPrecision"
                                             :class="i_isfrom==1&&scope.row.f_bcfpnum!=scope.row.f_fpnum?'red changeinput':'changeinput'"
                                             size="mini" v-model="scope.row.f_bcfpnum"></el-input-number>
                        </template>&ndash;&gt;
                        <template slot-scope="scope">
                            <el-input-number :disabled="scope.row.i_type==0?true:false"
                                             @change="inbcfnum(tableData,scope.$index,scope.row)" :controls="false"
                                             :precision="$setPrecision.quantityPrecision"
                                             :class="i_isfrom==1&&scope.row.f_bcfpnum!=scope.row.f_fpnum?'red changeinput':'changeinput'"
                                             size="mini" v-model="scope.row.f_bcfpnum"></el-input-number>
                        </template>
                    </el-table-column>
                    &lt;!&ndash;<el-table-column
                            v-if="i_fytype!=1"
                            prop="vc_unit"
                            label="订单单位"
                            show-overflow-tooltip
                            width="116">
                    </el-table-column>
                    <el-table-column
                            v-if="i_fytype!=1"
                            prop="f_num"
                            :label="$t('invoiceEntry_order_quantity')"
                            show-overflow-tooltip
                            width="150">
                        <template slot-scope="scope">
                            &lt;!&ndash;:disabled="scope.row.i_type==0?true:isred"&ndash;&gt;
                            <el-input-number :disabled="scope.row.unit=='no'||i_isfrom==0?false:true"  @change="infnum(tableData,scope.$index,scope.row)"  :controls="false" :precision="5"  :class="i_isfrom==1&&scope.row.f_num!=scope.row.f_fpnum?'red changeinput':'changeinput'" size="mini" v-model="scope.row.f_num" ></el-input-number>
                        </template>
                    </el-table-column>&ndash;&gt;
                    <el-table-column
                            v-if="i_issd==1||i_isagent==1"
                            prop="f_rate"
                            :label="$t('form_exchange_rate')"
                            show-overflow-tooltip
                            width="150">
                        <template slot-scope="scope">
                            <el-input-number :disabled="scope.row.i_type==0?true:isred"
                                             @change="infrate(tableData,scope.$index,scope.row)" :controls="false"
                                             :min="0" :precision="$setPrecision.quantityPrecision" class="changeinput" size="mini"
                                             v-model="scope.row.f_rate"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column
                            v-if="i_flag==1"
                            prop="f_price_yb"
                            :label="$t('invoiceEntry_original_currency_unit_price')"
                            show-overflow-tooltip
                            width="110"
                            key="f_price_yb">
                        <template slot-scope="scope">
                            <span>{{scope.row.f_price_yb+scope.row.vc_bzsymbol}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            v-if="i_fytype!=1"
                            prop="f_price_ws"
                            :label="$t('invoiceEntry_unit_price_excluding_tax')"
                            show-overflow-tooltip
                            width="130"
                            align="right">
                        <template slot-scope="scope">
                            <div :class="i_isfrom==1&&scope.row.f_price_ws!=scope.row.f_fpprice?'red':''">
                                {{scope.row.f_price_ws}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="f_pay_ws"
                            :label="i_flag==1?$t('invoiceEntry_taxable_amount_including_customs_duties'):$t('invoiceEntry_tax-exempt_amount') "
                            show-overflow-tooltip
                            width="150"
                            align="right">
                        <template slot-scope="scope">
                            <span v-if="(i_isfrom==1&&!isred)||(i_isfrom==1&&i_fytype!=1)" :class="i_isfrom==1&&scope.row.f_pay_ws!=scope.row.f_fppay_ws?'red':''">{{scope.row.f_pay_ws}}</span>
                            <el-input-number v-if="i_isfrom==0||(i_isfrom==1&&i_fytype==1&&isred)" :disabled="scope.row.i_type==0?true:(i_fytype==1&&isred?false:isred)"
                                             @change="infpay(tableData,scope.$index,scope.row)" :controls="false"
                                             :precision="2"
                                             :class="i_isfrom==1&&scope.row.f_pay_ws!=scope.row.f_fppay_ws?'red changeinput':'changeinput'"
                                             size="mini" v-model="scope.row.f_pay_ws"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column
                            v-if="i_flag==1"
                            :label="$t('invoiceEntry_tariff')"
                            show-overflow-tooltip
                            width="150">
                        <template slot-scope="scope">
                            <el-input-number :disabled="true" @change="paygs(tableData,scope.$index,scope.row)"
                                             :controls="false" :min="0" :precision="2" class="changeinput" size="mini"
                                             v-model="scope.row.f_pay_gs"></el-input-number>
                        </template>
                    </el-table-column>

                    <el-table-column
                            prop="f_sl"
                            :label="$t('form_tax_rate')"
                            show-overflow-tooltip
                            width="150"
                            align="right">
                        <template slot-scope="scope">
                            <span v-if="i_isfrom==1" >{{scope.row.f_sl}}</span>
                            <el-input-number v-else :disabled="scope.row.i_type==0?true:isred"
                                             @change="infsl(tableData,scope.$index,scope.row)" :controls="false"
                                             :min="0" :precision="2" class="changeinput" size="mini"
                                             v-model="scope.row.f_sl"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="f_pay_zzs"
                            :label="$t('invoiceEntry_tax_amount')"
                            show-overflow-tooltip
                            width="150"
                            align="right">
                        <template slot-scope="scope">
                            <span v-if="i_isfrom==1" :class="i_isfrom==1&&scope.row.f_pay_zzs!=scope.row.f_fppay_zzs?'red':''">{{scope.row.f_pay_zzs}}</span>
                            <el-input-number v-else :disabled="scope.row.i_type==0?true:isred"
                                             @change="sepay(tableData,scope.$index,scope.row)" :controls="false"
                                             :precision="2"
                                             :class="i_isfrom==1&&scope.row.f_pay_zzs!=scope.row.f_fppay_zzs?'red changeinput':'changeinput'"
                                             size="mini" v-model="scope.row.f_pay_zzs"></el-input-number>
                        </template>
                    </el-table-column>
                    &lt;!&ndash;<el-table-column  align="center"  width="50" v-if="!isred&&i_fytype!=1">
                        &lt;!&ndash;v-if="i_flag!=1"&ndash;&gt;
                        <template slot="header" slot-scope="scope" >
                            <el-button class="popaddbtn" @click="popShow"  :disabled="isbtn" ><i class="el-icon-plus"></i></el-button>
                        </template>
                        &lt;!&ndash;v-if="i_flag!=1"&ndash;&gt;
                        <template  slot-scope="scope" >
                            &lt;!&ndash; v-if="!scope.row.vc_fkey_sub"&ndash;&gt;
                            <div class="iconminus">
                                &lt;!&ndash;v-show="!isedit"&ndash;&gt;
                                <span class="minus"   @click="deleteRow(scope.row,scope.$index)"><i class="el-icon-minus"></i></span>
                            </div>
                        </template>
                    </el-table-column>&ndash;&gt;
                </el-table>-->
                <el-table
                        ref="table"
                        size="mini"
                        border
                        :data="flattenTableData"
                        :span-method="arraySpanMethod"
                        :height="tableHeight"
                        style="width: 100%"
                        class="marT10"
                        :header-cell-style="{background:'#eef1f6',color:'#000'}">

                    <!--<el-table-column
                            type="index"
                            label=""
                            show-overflow-tooltip
                            width="35">
                    </el-table-column>-->
                    <el-table-column :label="$t('form_serial_number')" width="48">
                        <template slot-scope="scope">
                            {{ scope.row._invoiceIndex}}
                            <i class="el-icon-warning" style="color: red;" v-if="scope.row.i_isdiffer&&scope.row.i_type==1"></i>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="vc_fppzname"
                            :label="$t('invoiceEntry_invoice_item_name')"
                            show-overflow-tooltip
                            min-width="350">
                        <template slot-scope="scope">
                            <!--<el-tooltip class="item" effect="dark"
                                        :content="scope.row.vc_fppzname+' /'+$t('invoiceEntry_specification_model')+'：'+scope.row.vc_fpbzstyle+' /'+$t('form_unit')+'：'+scope.row.vc_fpunit+' /'+$t('form_quantity')+'：'+scope.row.f_fpnum+' /'+$t('form_unit_price')+'：'+scope.row.f_fpprice+' /'+$t('form_amount')+'：'+scope.row.f_fppay_ws+' /'+$t('invoiceEntry_tax_amount')+'：'+scope.row.f_fppay_zzs"
                                        placement="top">-->
                            <div class="fppm">
                                <span>{{scope.row.vc_fppzname+' /'+$t('invoiceEntry_specification_model')+'：'+scope.row.vc_fpbzstyle+' /'+$t('form_unit')+'：'+scope.row.vc_fpunit+' /'+$t('form_quantity')+'：'+scope.row.f_fpnum+' /'+$t('form_unit_price')+'：'+scope.row.f_fpprice+' /'+$t('form_amount')+'：'+scope.row.f_fppay_ws+' /'+$t('form_tax_rate')+'：'+scope.row.f_sl+' /'+$t('invoiceEntry_tax_amount')+'：'+scope.row.f_fppay_zzs}}</span>
                                <span class="blue" @click="goOrder(tableData,scope.$index,scope.row)">{{scope.row.i_type==0?'-':' ['+$t('invoiceEntry_select_the_inventory_receipt_freight_bill')+']' }}</span>
                                <span class="blue" v-if="scope.row.i_isSplit==1&&scope.row.i_type==1">{{$t('invoiceEntry_the_tax_excluded_amount_of_the_invoice_after_component_disassembly')+':'+scope.row.f_pay_ws+';'+$t('invoiceEntry_tax_amount')+':'+scope.row.f_pay_zzs}}</span>
                            </div>
                            <!--</el-tooltip>-->
                            <!--<span class="fppm">{{scope.row.vc_fppzname+' /'+$t('invoiceEntry_specification_model')+'：'+scope.row.vc_fpbzstyle+' /'+$t('form_unit')+'：'+scope.row.vc_fpunit+' /'+$t('form_quantity')+'：'+scope.row.f_fpnum+' /'+$t('form_unit_price')+'：'+scope.row.f_fpprice+' /'+$t('form_amount')+'：'+scope.row.f_fppay_ws+' /'+$t('invoiceEntry_tax_amount')+'：'+scope.row.f_fppay_zzs}}</span>-->
                        </template>
                    </el-table-column>
                    <!--<el-table-column
                            prop="vc_pzname"
                            :label="$t('invoiceEntry_project_name')"
                            show-overflow-tooltip
                            min-width="110">
                        <template slot-scope="scope">
                            <el-popover
                                    class="pop"
                                    :tabindex="scope.$index"
                                    :id="scope.$index+'pop'"
                                    placement="bottom-end"
                                    width="1000"
                                    trigger="manual"
                                    v-model="scope.row.visible"
                                    style="z-index: 9999">
                                &lt;!&ndash;<template>
                                    <product-details v-if="scope.row.visible==true&&i_fytype!=1" :productDetails="productDetails" @closePop="closePop(scope.$index)" @transValue="transValue"></product-details>
                                    <product-detailsnew ref="varietySelector" v-if="scope.row.visible==true&&i_fytype==1"
                                                        :varieties="varieties"
                                                        :invoices="invoices"
                                                        @confirm="onVarietyConfirm" :productDetails="productDetails" @closePop="closePop(scope.$index)" @transValue="transValue"></product-detailsnew>
                                </template>&ndash;&gt;
                                <span v-if="i_fytype!=1" slot="reference"
                                      @click="goOrder(tableData,scope.$index,scope.row)"
                                      class="blue">{{scope.row.i_type==0?'-':(scope.row.vc_pzname==''?'['+'请选择入库单'+']':scope.row.vc_pzname) }}</span>
                                &lt;!&ndash;+' '+scope.row.vc_cd+scope.row.vc_gykh+scope.row.vc_bzstyle&ndash;&gt;
                                <span v-else slot="reference" @click="goOrder(tableData,scope.$index,scope.row)"
                                      class='blue'>{{scope.row.vc_fppzname}}</span>
                            </el-popover>
                        </template>
                    </el-table-column>-->
                    <!--<el-table-column
                            v-if="i_isfrom==1&&i_type==2&&i_id==0"
                            prop="vc_bzstyle"
                            :label="$t('invoiceEntry_split_components')"
                            show-overflow-tooltip
                            min-width="85">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.i_type==1" class="popaddbtn"
                                       @click="splitdata(scope.row,scope.$index)"><i class="el-icon-plus backgw"></i>
                            </el-button>
                        </template>
                    </el-table-column>-->
                    <!--<el-table-column
                            v-if="i_fytype!=1"
                            prop="vc_bzstyle"
                            :label="$t('invoiceEntry_specification_model')"
                            show-overflow-tooltip
                            width="80">
                    </el-table-column>-->
                    <!--<el-table-column
                            v-if="i_isfrom==1&&i_fytype!=1"
                            prop="vc_fpunit"
                            :label="$t('invoiceEntry_invoice_unit')"
                            show-overflow-tooltip
                            min-width="80">
                    </el-table-column>-->
                    <!--<el-table-column
                            v-if="i_isfrom==1&&i_fytype!=1"
                            prop="f_bcfpnum"
                            :label="$t('invoiceEntry_invoice_quantity')"
                            show-overflow-tooltip
                            min-width="80"
                            align="right">
                        &lt;!&ndash;<template slot-scope="scope">
                            <span v-if="scope.row.f_pay_ws<0" >{{scope.row.f_bcfpnum}}</span>
                            <el-input-number v-else :disabled="scope.row.i_type==0?true:isred"
                                             @change="inbcfnum(tableData,scope.$index,scope.row)" :controls="false"
                                             :precision="$setPrecision.quantityPrecision"
                                             :class="i_isfrom==1&&scope.row.f_bcfpnum!=scope.row.f_fpnum?'red changeinput':'changeinput'"
                                             size="mini" v-model="scope.row.f_bcfpnum"></el-input-number>
                        </template>&ndash;&gt;
                        <template slot-scope="scope">
                            <span >{{scope.row.f_bcfpnum}}</span>
                            &lt;!&ndash;<el-input-number :disabled="scope.row.i_type==0?true:false"
                                             @change="inbcfnum(tableData,scope.$index,scope.row)" :controls="false"
                                             :precision="$setPrecision.quantityPrecision"
                                             :class="i_isfrom==1&&scope.row.f_bcfpnum!=scope.row.f_fpnum?'red changeinput':'changeinput'"
                                             size="mini" v-model="scope.row.f_bcfpnum"></el-input-number>&ndash;&gt;
                        </template>
                    </el-table-column>-->
                    <!--<el-table-column
                            v-if="i_fytype!=1"
                            prop="vc_unit"
                            label="订单单位"
                            show-overflow-tooltip
                            width="116">
                    </el-table-column>
                    <el-table-column
                            v-if="i_fytype!=1"
                            prop="f_num"
                            :label="$t('invoiceEntry_order_quantity')"
                            show-overflow-tooltip
                            width="150">
                        <template slot-scope="scope">
                            &lt;!&ndash;:disabled="scope.row.i_type==0?true:isred"&ndash;&gt;
                            <el-input-number :disabled="scope.row.unit=='no'||i_isfrom==0?false:true"  @change="infnum(tableData,scope.$index,scope.row)"  :controls="false" :precision="5"  :class="i_isfrom==1&&scope.row.f_num!=scope.row.f_fpnum?'red changeinput':'changeinput'" size="mini" v-model="scope.row.f_num" ></el-input-number>
                        </template>
                    </el-table-column>-->
                    <!--<el-table-column
                            v-if="i_issd==1||i_isagent==1"
                            prop="f_rate"
                            :label="$t('form_exchange_rate')"
                            show-overflow-tooltip
                            min-width="150">
                        <template slot-scope="scope">
                            <el-input-number :disabled="scope.row.i_type==0?true:isred"
                                             @change="infrate(tableData,scope.$index,scope.row)" :controls="false"
                                             :min="0" :precision="$setPrecision.quantityPrecision" class="changeinput" size="mini"
                                             v-model="scope.row.f_rate"></el-input-number>
                        </template>
                    </el-table-column>-->
                    <!--<el-table-column
                            v-if="i_flag==1"
                            prop="f_price_yb"
                            :label="$t('invoiceEntry_original_currency_unit_price')"
                            show-overflow-tooltip
                            min-width="110"
                            key="f_price_yb">
                        <template slot-scope="scope">
                            <span>{{scope.row.f_price_yb+scope.row.vc_bzsymbol}}</span>
                        </template>
                    </el-table-column>-->
                    <!--<el-table-column
                            v-if="i_fytype!=1"
                            prop="f_price_ws"
                            :label="$t('invoiceEntry_unit_price_excluding_tax')"
                            show-overflow-tooltip
                            min-width="100"
                            align="right">
                        <template slot-scope="scope">
                            <div :class="i_isfrom==1&&scope.row.f_price_ws!=scope.row.f_fpprice?'red':''">
                                {{scope.row.f_price_ws}}
                            </div>
                        </template>
                    </el-table-column>-->
                    <!--<el-table-column
                            prop="f_pay_ws"
                            :label="i_flag==1?$t('invoiceEntry_taxable_amount_including_customs_duties'):$t('invoiceEntry_tax-exempt_amount') "
                            show-overflow-tooltip
                            min-width="125"
                            align="right">
                        <template slot-scope="scope">
                            <span v-if="(i_isfrom==1&&!isred)||(i_isfrom==1&&i_fytype!=1)" :class="i_isfrom==1&&scope.row.f_pay_ws!=scope.row.f_fppay_ws?'red':''">{{scope.row.f_pay_ws}}</span>
                            <el-input-number v-if="i_isfrom==0||(i_isfrom==1&&i_fytype==1&&isred)" :disabled="scope.row.i_type==0?true:(i_fytype==1&&isred?false:isred)"
                                             @change="infpay(tableData,scope.$index,scope.row)" :controls="false"
                                             :precision="2"
                                             :class="i_isfrom==1&&scope.row.f_pay_ws!=scope.row.f_fppay_ws?'red changeinput3':'changeinput3'"
                                             size="mini" v-model="scope.row.f_pay_ws"></el-input-number>
                        </template>
                    </el-table-column>-->
                    <!--<el-table-column
                            v-if="i_flag==1"
                            :label="$t('invoiceEntry_tariff')"
                            show-overflow-tooltip
                            min-width="125">
                        <template slot-scope="scope">
                            <el-input-number :disabled="true" @change="paygs(tableData,scope.$index,scope.row)"
                                             :controls="false" :min="0" :precision="2" class="changeinput" size="mini"
                                             v-model="scope.row.f_pay_gs"></el-input-number>
                        </template>
                    </el-table-column>-->
                    <!--<el-table-column
                            prop="f_sl"
                            :label="$t('form_tax_rate')"
                            show-overflow-tooltip
                            min-width="95"
                            align="right">
                        <template slot-scope="scope">
                            <span v-if="i_isfrom==1" >{{scope.row.f_sl}}</span>
                            <el-input-number v-else :disabled="scope.row.i_type==0?true:isred"
                                             @change="infsl(tableData,scope.$index,scope.row)" :controls="false"
                                             :min="0" :precision="2" class="changeinput_mini" size="mini"
                                             v-model="scope.row.f_sl"></el-input-number>
                        </template>
                    </el-table-column>-->
                    <!--<el-table-column
                            prop="f_pay_zzs"
                            :label="$t('invoiceEntry_tax_amount')"
                            show-overflow-tooltip
                            min-width="125"
                            align="right">
                        <template slot-scope="scope">
                            <span v-if="i_isfrom==1" :class="i_isfrom==1&&scope.row.f_pay_zzs!=scope.row.f_fppay_zzs?'red':''">{{scope.row.f_pay_zzs}}</span>
                            <el-input-number v-else :disabled="scope.row.i_type==0?true:isred"
                                             @change="sepay(tableData,scope.$index,scope.row)" :controls="false"
                                             :precision="2"
                                             :class="i_isfrom==1&&scope.row.f_pay_zzs!=scope.row.f_fppay_zzs?'red changeinput3':'changeinput3'"
                                             size="mini" v-model="scope.row.f_pay_zzs"></el-input-number>
                        </template>
                    </el-table-column>-->
                    <template v-if="i_fytype!=1">
                        <el-table-column
                                prop="i_order_type"
                                :label="$t('invoiceEntry_type')"
                                show-overflow-tooltip
                                min-width="80">
                            <template slot-scope="scope">
                                <span>{{scope.row.i_order_type==1?$t('invoiceEntry_warehouse_receipt'):(scope.row.i_order_type==2?$t('invoiceEntry_loss_in_transit_order'):(scope.row.i_order_type==3?$t('invoiceEntry_orders_in_transit'):''))}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                key="type1_vc_pzname"
                                prop="vc_pzname"
                                :label="$t('form_product_name')"
                                show-overflow-tooltip
                                min-width="135">
                        </el-table-column>
                        <el-table-column
                                prop="vc_no"
                                :label="$t('form_batch_number')"
                                show-overflow-tooltip
                                min-width="155">
                        </el-table-column>
                        <el-table-column
                                prop="i_order_pid"
                                :label="$t('invoiceEntry_document_number')"
                                show-overflow-tooltip
                                min-width="80">
                        </el-table-column>
                        <el-table-column
                                prop="f_currentrelated_num"
                                :label="$t('invoiceEntry_associated_quantity')"
                                show-overflow-tooltip
                                min-width="110"
                                align="right">
                        </el-table-column>
                        <el-table-column
                                prop="f_currentrelate_num_fp"
                                :label="$t('invoiceEntry_invoice_quantity')"
                                show-overflow-tooltip
                                min-width="110"
                                align="right">
                        </el-table-column>
                        <!--<el-table-column
                                prop="vc_fpunit"
                                :label="$t('invoiceEntry_invoice_unit')"
                                show-overflow-tooltip
                                width="80"
                                align="right">
                        </el-table-column>-->
                        <el-table-column
                                prop="f_je_ws"
                                :label="$t('invoiceEntry_tax-excluded_amount_on_the_invoice')"
                                show-overflow-tooltip
                                min-width="110"
                                align="right">
                        </el-table-column>
                        <el-table-column
                                prop="f_sl"
                                :label="$t('form_tax_rate')"
                                show-overflow-tooltip
                                min-width="80"
                                align="right">
                        </el-table-column>
                        <el-table-column
                                prop="f_je_zzs"
                                :label="$t('invoiceEntry_tax_amount')"
                                show-overflow-tooltip
                                min-width="110"
                                align="right">
                        </el-table-column>
                        <!--<el-table-column
                                align="right"
                                prop="f_num_tol"
                                :label="$t('invoiceEntry_total_order_quantity')"
                                show-overflow-tooltip
                                width="80">
                        </el-table-column>-->
                        <el-table-column
                                prop="vc_unit"
                                :label="$t('form_unit')"
                                show-overflow-tooltip
                                min-width="80">
                        </el-table-column>
                        <!--<el-table-column
                                align="right"
                                prop="f_fkpay_tol"
                                :label="$t('invoiceEntry_amount_already_paid_for_the_order')"
                                show-overflow-tooltip
                                width="80">
                        </el-table-column>
                        <el-table-column
                                align="right"
                                prop="f_related_num"
                                :label="$t('invoiceEntry_already_associated_quantity')"
                                show-overflow-tooltip
                                width="80">
                        </el-table-column>
                        <el-table-column
                                align="right"
                                prop="f_canrelate_num"
                                :label="$t('invoiceEntry_can_be_associated_with_quantity')"
                                show-overflow-tooltip
                                width="80">
                        </el-table-column>-->
                        <el-table-column
                                prop="f_bl"
                                :label="$t('invoiceEntry_proportion')"
                                show-overflow-tooltip
                                min-width="80"
                                align="right">
                        </el-table-column>
                    </template>
                    <template v-else>
                        <el-table-column
                                key="type2_vc_pzname"
                                prop="vc_pzname"
                                :label="$t('form_product_name')"
                                show-overflow-tooltip
                                min-width="130">
                        </el-table-column>
                        <el-table-column
                                prop="vc_no"
                                :label="$t('form_batch_number')"
                                show-overflow-tooltip
                                min-width="155">
                        </el-table-column>
                        <el-table-column
                                prop="vc_code"
                                :label="$t('invoiceEntry_document_number')"
                                show-overflow-tooltip
                                min-width="155">
                        </el-table-column>
                        <el-table-column
                                prop="vc_xcode"
                                :label="$t('invoiceEntry_sales_order_number')"
                                show-overflow-tooltip
                                min-width="100">
                        </el-table-column>
                        <el-table-column
                                prop="f_je"
                                :label="$t('invoiceEntry_this_associated_invoice_amount')"
                                show-overflow-tooltip
                                align="right"
                                min-width="110">
                        </el-table-column>
                        <el-table-column
                                prop="f_je_ws"
                                :label="$t('invoiceEntry_tax-excluded_amount_on_the_invoice')"
                                show-overflow-tooltip
                                min-width="110"
                                align="right">
                        </el-table-column>
                        <el-table-column
                                align="right"
                                prop="f_sl"
                                :label="$t('form_tax_rate')"
                                show-overflow-tooltip
                                width="80">
                        </el-table-column>
                        <el-table-column
                                prop="f_je_zzs"
                                :label="$t('invoiceEntry_tax_amount')"
                                show-overflow-tooltip
                                min-width="110"
                                align="right">
                        </el-table-column>
                    </template>

                    <!--<el-table-column label="操作" width="150" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="openOrderModal(scope.row.id)">
                                [请选择品种]
                            </el-button>
                        </template>
                    </el-table-column>-->
                </el-table>
                <div class="flex_b w100 marT10">
                    <div class="flex w50 alc" >
                        <span class="marr4 font14">{{$t('invoiceEntry_total_price_and_tax_in_words')}}</span>
                        <span class="marr4 font14">{{vc_lang=='zh_cn'?DtotalPrice:totalPrice}}</span>
                    </div>
                    <div class="w50 txtE">
                        <span class="marr4 font14">{{'（'+$t('invoiceEntry_lowercase')+'）'+totalPrice}}</span>
                    </div>
                </div>
                <div class="flex_e w100 marT10 alc">
                    <!--<ul>
                        <li v-for="(oneimg,index) in filesfp" :key="index">
                            <a :href="file_root+oneimg.vc_mainfile_newname" target="_blank">
                                {{oneimg.vc_filename}}
                            </a>
                        </li>
                    </ul>-->
                    <span v-if="isred" class="marr4 font14">{{'（'+$t('invoiceEntry_associated_invoice_amount')+'）'+spillfppay}}</span>
                </div>
                <div class="flex w100 marT10 alc">
                    <span class="marr4 font14">{{$t('invoiceEntry_invoice_remarks')}}</span>
                    <el-input class="wid100" size="mini" v-model="formData.vc_note">
                    </el-input>
                </div>
                <div class="flex w100 marT10">
                    <div class="w50 alc txt">
                        <span class="w100 marr4 font14">{{$t('invoiceEntry_handler')}} </span>
                        <span class="w100 font14">{{formData.vc_lruname}}</span>
                    </div>
                    <div class="w50 txt">
                        <span class="w100 marr4 font14">{{$t('invoiceEntry_processing_date')}} </span>
                        <span class="w100 font14">{{formData.dt_createtime}}</span>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer" style="text-align: center;padding: 6px">
                <el-button type="danger" v-if="i_id!=0&&i_checkstate=='0'" @click="toVoid" :disabled="disabled"
                           size="small">{{$t('button_nullify')}}
                </el-button>
                <el-button type="primary" v-if="i_id==0||i_checkstate=='0'" @click="saveForm" :disabled="disabled"
                           :class="baseerp+'btn'" size="small">{{$t('button_save')}}
                </el-button>
                <el-button type="danger" v-if="i_id!=0&&i_checkstate=='0'" @click="tosubmit" :disabled="disabled"
                           size="small">{{$t('button_submit_for_approval')}}
                </el-button>
                <el-button @click="cancel(isshua)" size="small">{{$t('button_cancel')}}</el-button>
            </div>
        </div>
        <el-dialog
                :class="baseerp+'div'"
                :style="{ maxHeight: maxDialogHeight + 'px', overflowY: 'auto' }"
                top="10vh"
                width="85%"
                :title="i_fytype==1?$t('invoiceEntry_fee_list'):$t('invoiceEntry_order_list')"
                :visible.sync="dialogVisible_order"
                :close-on-click-modal="false"
                @close="onVarietyConfirm({type:'back'})"
                v-if="dialogVisible_order"
                :append-to-body="true">
            <!--<payapplic-list v-if='i_fytype==1' :dataOrd="dataOrd" @cancelDialog_order="cancelDialog_order"></payapplic-list>-->
            <cost-list v-if='i_fytype==1' :dataOrd="dataOrd" @confirm="onVarietyConfirm"></cost-list>
            <ord-list v-else :dataOrd="dataOrd" @confirm="onVarietyConfirm"></ord-list>
        </el-dialog>
        <el-dialog
                :class="baseerp+'div'"
                width="1000px"
                :title="$t('invoiceEntry_related_invoice')"
                :visible.sync="dialogVisible_fpcnew"
                :close-on-click-modal="false"
                @close="cancelDialog_fpcnew"
                v-if="dialogVisible_fpcnew"
                :append-to-body="true">
            <fpc-listnew @cancelDialog_fpcnew="cancelDialog_fpcnew" :fpData="fpData"></fpc-listnew>
        </el-dialog>
        <!--<el-dialog
                :class="baseerp+'div'"
                width="1000px"
                title="关联订单"
                :visible.sync="dialogVisible_connect"
                :close-on-click-modal="false"
                @close="cancelDialog_connect"
                v-if="dialogVisible_connect"
                :append-to-body="true">
            <connect-list  :dataConnect="dataConnect" @cancelDialog_connect="cancelDialog_connect"></connect-list>
        </el-dialog>-->
        <!--<el-dialog
                :class="baseerp+'div'"
                width="1000px"
                title="预览明细"
                :visible.sync="dialogVisible_mx"
                :close-on-click-modal="false"
                @close="cancelDialog_mx"
                v-if="dialogVisible_mx"
                :append-to-body="true">
            <mx-list :dataMx="dataMx" @cancelDialog_mx="cancelDialog_mx" @saveForm="saveForm"></mx-list>
        </el-dialog>-->
        <el-dialog
                :class="baseerp+'div'"
                width="800px"
                :title="$t('invoiceEntry_split_component_invoicing')"
                :visible.sync="dialogVisible_alert"
                :close-on-click-modal="false"
                @close="cancelDialog_alert"
                v-if="dialogVisible_alert"
                :append-to-body="true">
            <alert-table :Data="alertdata"
                         @close="cancelDialog_alert"
                         @confirm="onSplitConfirm"></alert-table>
        </el-dialog>
    </div>

</template>


<script>
    import * as API from "./api";
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    import {baseApp} from "@/utils/baseUrl";
    import {file_url} from "@/utils/baseUrl";
    import {file_root} from "@/utils/baseUrl";
    import {baseVersion} from "@/utils/baseUrl";
    //import ProductDetails from "./ProductDetails";
    //import ProductDetailsnew from "./ProductDetailsnew";
    import fpcListnew from "./fpcListnew";
    import ordList from "./ordList";
    //import payapplicList from "./payapplicList";
    import costList from "./costList";
    //import connectList from './connectList';
    //import mxList from "./mxList";
    import alertTable from "./alertTable";

    export default {
        components: {
            //ProductDetails,
            //ProductDetailsnew,
            ordList,
            fpcListnew,
            //payapplicList,
            costList,
            //connectList,
            //mxList,
            alertTable
        },
        props: {
            Data: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                needsave:false,
                tableHeight: 450,
                maxDialogHeight: 0,
                currentMainRow: null,
                dialogVisible_alert: false,
                alertdata: {},
                dataMx: {},
                dialogVisible_connect: false,
                dataConnect: {},
                i_fytype: 0,
                copynote: '',
                copyfpcode: '',
                isshua: 0,
                fpData: {},
                isred: false,
                i_invoiceType: '1',
                vc_relateinvoice_code: '',
                i_glfpid: 0,
                loading: false,
                showTable: true,
                orderids: [],
                orderWs: '',
                dataOrd: {},
                vc_newname: "",
                filesfp: [],
                imgList: [],
                imgLength: 0,
                baseerp: "",
                file_url: '',
                file_root: "",
                baseApp: "",
                baseVersion: "",
                erpplatserver: "",
                type: '',
                i_isfrom: 0,
                i_id: 0,
                fptotalPrice: 0,
                totalPrice: 0,
                sqtotalPrice: 0,
                DtotalPrice: '',
                f_pay_ws: 0,
                f_pay_zzs: 0,
                f_pay_gs: 0,
                delIds: [],
                disinput_fpcode: false,//发票code
                disinput2: false,//daikai/xiaoshou
                disinput: false,//禁下拉输入
                disabled: false,//禁保存
                isbtn: false,//禁减号
                isedit: false,//禁单选
                visible: false,
                dialogVisible_fpc: false,
                dialogVisible_fpcnew: false,
                dialogVisible_order: false,
                dialogVisible_mx: false,
                productDetails: {},
                i_isagent: 0,//是否开单
                isdk: 0,//是否可开单
                codeData: [],
                vc_fkey: 0,
                vc_fpcode: "",
                compsData: [],
                companyName: '',
                companyId: 0,
                vc_gscreditcode: "",
                lastCheckOutDate:'',
                xsData: [],
                xsComname: '',
                xsComId: 0,
                kpfData: [],
                i_kpkhid: 0,
                vc_kpkhname: '',
                vc_khcreditcode: "",
                fpType: [],
                i_type: 0,
                i_khtype: 0,
                i_origin_khtype: 0,
                vc_fymx: '',
                i_issd: 0,
                i_flag: 0,
                vc_type: "",
                fplxData: [],
                i_fptype: null,
                vc_fptype: '',
                f_sl: 0,
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now()  // - 8.64e7;如果要禁用到当前日期则去掉 - 8.64e7
                    },
                },
                formData: {
                    files: [],
                    dt_fptime: '',
                    vc_fpcode: '',
                    vc_lruname: sessionStorage.getItem("lruname"),
                    dt_createtime: '',
                    dt_cwtime:'',
                },
                tableData: [],
                yuanshi: [],
                selectD: [],
                details_ord: [],
                details_form: {},
                disselect: [],
                bzData: [],
                vc_bzname: "",
                i_bzid: 0,
                f_rate: 0,
                i_checkstate: '',
                i_bzid_yb: 0,
                flagpzList: [],
                multipleSelection: [],
                detmx: [],
                pzdetails: [],
                xtbc: false,
                splitparts: [],
                pickorderlist: [],
                varieties: [],
                invoices: [],
                currentInvoiceId: null,
                reverseId:0,
                spillfppay:0,
                deletedDataIds:[],
                vc_lang:'',
            }
        },
        updated() {
            if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs['table'].doLayout();
            }

        },
        watch: {
            i_isfrom() {
                //console.log(this.i_isfrom, 'i_isfrom');
                this.refreshTable();
            },
            immediate: true,
            deep: true,
        },
        computed: {
            flattenTableData() {
                const result = [];
                this.tableData.forEach((invoice,i) => {
                    if (!invoice.details || invoice.details.length === 0) {
                        result.push({
                            ...invoice,
                            _invoiceIndex: i + 1,
                            _rowSpan: 1,       // 这一块只占 1 行
                            _isFirst: true,     // 是第一行（负责主表合并单元格渲染）
                            i_order_type: '',
                            i_order_pid: '',
                            vc_pzname: '',
                            vc_no: '',
                            f_num_tol: '' ,
                            vc_unit:'',
                            f_fkpay_tol:'',
                            f_related_num: '',
                            f_canrelate_num: '',
                            f_currentrelated_num: '',
                            f_bl: '',
                            f_currentrelate_num_fp: '',
                            f_je_ws: '',
                            f_je_zzs: '',
                            f_je:'',
                            vc_code:'',
                            vc_xcode:'',
                        });
                    } else {
                        invoice.details.forEach((detail, index) => {
                            result.push({
                                ...invoice,
                                ...detail,
                                vc_pzname: detail.vc_pzname,
                                vc_fppzname: invoice.vc_fppzname,
                                vc_fpbzstyle: invoice.vc_fpbzstyle,
                                i_type:invoice.i_type,
                                _invoiceIndex: i + 1,
                                _rowSpan: invoice.details.length, // 这组发票需要向下合并的行数
                                _isFirst: index === 0             // 只有第一行设为 true 触发合并逻辑
                            });
                        });
                        //console.log(result,'result')
                    }
                });

                return result;
            }
        },
        mounted() {
            this.baseerp = baseerp;
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
            this.file_url = file_url;
            this.file_root = file_root;
            this.file = this.file_url;
            this.token = sessionStorage.getItem('token');
            this.i_uid = sessionStorage.getItem('userid');
            this.vc_lang = sessionStorage.getItem('vc_lang');
            console.log(this.vc_lang, 'this.vc_lang');
            //console.log(this.Data, 'this.Data');
            this.type = this.Data.type;

            if (this.type == 'add') {
                this.getDateYYYYMMddHHMMSS();
                this.fptype();
                this.fplx();
                this.getCompanyList();
                this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);
                this.i_checkstate = '0';
                this.updateTableHeight();
                window.addEventListener('resize', this.updateTableHeight);
            };
            if (this.type == 'edit') {
                this.loading = false;
                this.i_isfrom = this.Data.row.i_isfrom;
                this.i_issd = this.Data.row.i_issd;
                this.i_flag = this.Data.row.i_flag;
                this.isedit = true;
                this.i_id = this.Data.row.i_id;
                this.isover = this.Data.row.isover;
                this.i_checkstate = this.Data.row.i_checkstate;
                this.i_gsid = this.Data.row.i_gsid;
                this.i_kpkhid =this.Data.row.i_kpkhid;
                this.$nextTick(() => {
                    this.detail()
                })
            };

        },
        beforeDestroy() {
            window.removeEventListener('resize', this.updateTableHeight);
        },
        methods: {
            changedate(){
                this.needsave=true;
            },
            updateTableHeight() {
                //console.log(this.Data.maxDialogHeight,'this.Data.maxDialogHeight');
                const dialogHeight = this.Data.maxDialogHeight; // 弹窗最大高度
                //console.log(dialogHeight,' dialogHeight');
                const otherHeight = this.isred?440:400;
                this.tableHeight = dialogHeight - otherHeight;
                //console.log( this.tableHeight,' this.tableHeight')
                this.maxDialogHeight =  this.Data.maxDialogHeight;
            },
            arraySpanMethod({ row, column, rowIndex, columnIndex }) {
                if (columnIndex < 2 ) {
                    if (row._isFirst) {
                        return { rowspan: row._rowSpan, colspan: 1 };
                    } else {
                        return { rowspan: 0, colspan: 0 };
                    }
                }
                /*if(this.i_isfrom==1){
                    if (this.i_fytype!=1&&columnIndex < 9 ) {
                        if (row._isFirst) {
                            return { rowspan: row._rowSpan, colspan: 1 };
                        } else {
                            return { rowspan: 0, colspan: 0 };
                        }
                    }
                    if (this.i_fytype==1&&columnIndex < 6 ) {
                        if (row._isFirst) {
                            return { rowspan: row._rowSpan, colspan: 1 };
                        } else {
                            return { rowspan: 0, colspan: 0 };
                        }
                    }
                }else{
                    if (this.i_fytype!=1&&columnIndex < 6 ) {
                        if (row._isFirst) {
                            return { rowspan: row._rowSpan, colspan: 1 };
                        } else {
                            return { rowspan: 0, colspan: 0 };
                        }
                    }
                    if (this.i_fytype==1&&columnIndex < 5 ) {
                        if (row._isFirst) {
                            return { rowspan: row._rowSpan, colspan: 1 };
                        } else {
                            return { rowspan: 0, colspan: 0 };
                        }
                    }
                }*/

            },
            delfil(row, index) {
                //console.log(row);
                this.$confirm('确认删除该附件吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.filesfp.splice(index, 1);
                    this.$message.success('删除成功');
                    if(!this.isred){
                        this.tableData = [];
                        this.orderWs = '';
                        this.orderids = [];
                        this.pickorderlist = [];
                        this.fptotalPrice = 0;
                        this.totalPrice = 0;
                        this.DtotalPrice = this.convertToChineseCapital(0);
                    }else{
                        this.formData.vc_fpcode = '';
                        this.spillfppay=0;
                    }

                }).catch(() => {});
            },
            opencodes() {
                if (this.i_fptype == null) {
                    this.$message.error(this.$t('invoiceEntry_please_enter_invoice_type')+'!');
                    return;
                }
                if (this.i_kpkhid == 0) {
                    this.$message.error(this.$t('invoiceEntry_please_select_the_invoicing_party')+'!');
                    return;
                }
                if (this.companyId == 0) {
                    this.$message.error(this.$t('invoiceEntry_please_select_the_buyer')+'!');
                    return;
                }
                if (this.i_isagent == 1 && this.xsComId == 0) {
                    this.$message.error(this.$t('invoiceEntry_please_select_the_seller')+'!');
                    return;
                }
                this.fpData = {
                    name: this.isred ? 'spill' : 'add',
                    i_type: this.i_type,
                    vc_type: this.vc_type,
                    i_fytype: this.i_fytype,
                    i_khtype: this.i_khtype,
                    i_origin_khtype: this.i_origin_khtype,
                    vc_fymx: this.vc_fymx,
                    isdk: this.isdk,
                    i_issd: this.i_issd,
                    i_flag: this.i_flag,
                    i_kpkhid: this.i_kpkhid,
                    vc_kpkhname: this.vc_kpkhname,
                    //i_kpkhid: this.i_isagent==1?this.xsComId:this.i_kpkhid , //销售方，代开时为销售方，非代开时为开票方
                    //vc_kpkhname:this.i_isagent==1?this.xsComname:this.vc_kpkhname ,//开票方
                    vc_khcreditcode: this.vc_khcreditcode,
                    companyId: this.companyId,
                    companyName: this.companyName,
                    vc_gscreditcode: this.vc_gscreditcode,
                    i_isagent: this.i_isagent,
                    //i_dlkhid: this.i_isagent==1?this.i_kpkhid:0 ,
                    //vc_dlkhname:this.i_isagent==1?this.vc_kpkhname:'' , //代理开票方,
                    i_fptype: this.i_fptype,
                    vc_fptype: this.vc_fptype,
                    copyfpcode: this.isred ? this.copyfpcode : null,
                    i_glfpid: this.isred ? this.i_glfpid : null,
                    i_invoiceType:this.i_invoiceType,
                }
                /*if(this.i_invoiceType==2){
                    this.copyfpcode=this.formData.vc_fpcode
                }*/
                this.dialogVisible_fpcnew = true;
            },
            spillover() {
                this.$confirm(this.$t('invoiceEntry_are_you_sure_about_flushing_red'), this.$t('tips_prompt'), {
                    confirmButtonText: this.$t('button_confirm'),
                    cancelButtonText: this.$t('button_cancel'),
                    type: 'warning'
                }).then(() => {
                    this.isred = true;
                    this.disinput2 = false;
                    this.disinput_fpcode = false;
                    this.i_id = 0;
                    this.copynote = this.formData.vc_note;
                    //this.copyfpcode = this.formData.vc_fpcode;
                    this.formData.vc_fpcode = '';
                    this.filesfp=[];
                    this.tableData.map(item => {
                        item.f_bcfpnum = item.f_bcfpnum * -1
                        item.f_fpnum = item.f_fpnum * -1
                        item.f_num = item.f_num * -1
                        item.f_pay_ws = item.f_pay_ws * -1
                        item.f_pay_zzs = item.f_pay_zzs * -1
                        item.f_fppay_ws = item.f_fppay_ws * -1
                        item.f_fppay_zzs = item.f_fppay_zzs * -1
                        item.details.map(subitem=>{
                            subitem.f_currentrelate_num_fp = subitem.f_currentrelate_num_fp * -1
                            subitem.f_currentrelated_num = subitem.f_currentrelated_num * -1
                            subitem.f_je_ws = subitem.f_je_ws * -1
                            subitem.f_je_zzs = subitem.f_je_zzs * -1
                            subitem.f_je = subitem.f_je * -1
                        })
                    })
                    //价税合计
                    let tp = 0;
                    let ts = 0;
                    this.tableData.map(item => {
                        tp += item.f_pay_ws;
                        ts += item.f_pay_zzs;
                    })
                    this.f_pay_ws = parseFloat(this.keepTwoDecimal(tp));
                    this.f_pay_zzs = parseFloat(this.keepTwoDecimal(ts));
                    let num = this.keepTwoDecimal(tp + ts);
                    this.totalPrice = this.returnFloat(num);
                    this.fptotalPrice = this.totalPrice;
                    this.DtotalPrice = this.$t('invoiceEntry_fu') + this.convertToChineseCapital(this.totalPrice * -1);
                    this.spillfppay = this.totalPrice;
                }).catch(() => {

                });

            },
            validateInvoices2(invoices) {
                //console.log('invoices',invoices)
                const mismatches = invoices.filter(invoice => {
                    let ordersTotal=0,ordersNum=0;
                    if(this.formData.i_fytype==1){
                        ordersTotal = Number(
                            invoice.details.reduce((sum, order) => {
                                return sum + Number(order.f_je || 0);
                            }, 0).toFixed(2)
                        );
                    }else{
                        // 计算订单总额（保留两位小数）
                        ordersTotal = Number(
                            invoice.details.reduce((sum, order) => {
                                return sum + Number(order.f_je_ws || 0) + Number(order.f_je_zzs || 0);
                            }, 0).toFixed(2)
                        );
                        ordersNum = Number(
                            invoice.details.reduce((sum, order) => {
                                return sum + Number(order.f_currentrelate_num_fp || 0) ;
                            }, 0).toFixed(2)
                        );
                    }
                    // 发票金额也保留两位小数
                    const fPay = Number(Number(invoice.f_pay || 0).toFixed(2));
                    const fPnum = Number(Number(invoice.f_fpnum || 0).toFixed(2));
                    if(this.i_isfrom==1&&this.formData.i_fytype!=1){
                        //console.log('fPay1',fPay,'ordersTotal',ordersTotal)
                        //console.log('fPnum',fPnum,'ordersNum',ordersNum)
                        if(invoice.f_fpnum==0){
                            return Math.round(fPay * 100) !== Math.round(ordersTotal * 100)
                        }else{
                            return Math.round(fPay * 100) !== Math.round(ordersTotal * 100)&&Math.round(fPnum * 100) !== Math.round(ordersNum * 100)
                        }
                    }else{
                        //console.log('fPay2',fPay,'ordersTotal',ordersTotal)
                        // 严格比较
                        return Math.round(fPay * 100) !== Math.round(ordersTotal * 100);
                    }

                });
                return {
                    isValid: mismatches.length === 0,
                    mismatches
                };
            },
            validateInvoices(invoices) {
                const mismatches = invoices.filter(invoice => {
                    let ordersTotal = 0, ordersNum = 0;
                    if (this.formData.i_fytype == 1) {
                        ordersTotal = Math.round(
                            invoice.details.reduce((sum, order) => {
                                return sum + Number(order.f_je || 0);
                            }, 0) * 100
                        );
                    } else {
                        ordersTotal = Math.round(
                            invoice.details.reduce((sum, order) => {
                                return sum +
                                    Number(order.f_je_ws || 0) +
                                    Number(order.f_je_zzs || 0);
                            }, 0) * 100
                        );
                        ordersNum = Math.round(
                            invoice.details.reduce((sum, order) => {
                                return sum + Number(order.f_currentrelate_num_fp || 0);
                            }, 0) * 100
                        );
                    }
                    const fPay = Math.round(Number(invoice.f_pay || 0) * 100);
                    const fPnum = Math.round(Number(invoice.f_fpnum || 0) * 100);
                    if (this.i_isfrom == 1 && this.formData.i_fytype != 1) {
                        //console.log('fPay1', fPay, 'ordersTotal', ordersTotal);
                        //console.log('fPnum', fPnum, 'ordersNum', ordersNum);
                        if (invoice.f_fpnum == 0) {
                            return fPay !== ordersTotal;
                        } else {
                            return (
                                fPay !== ordersTotal ||
                                fPnum !== ordersNum
                            );
                        }
                    } else {
                        //console.log('fPay2', fPay, 'ordersTotal', ordersTotal);
                        return fPay !== ordersTotal;
                    }
                });
                return {
                    isValid: mismatches.length === 0,
                    mismatches
                };
            },
            toVoid(){
                this.$confirm(this.$t('invoiceEntry_are_you_sure_to_submit_for_void'), this.$t('tips_prompt'), {
                    confirmButtonText: this.$t('button_sure'),
                    cancelButtonText: this.$t('button_cancel'),
                    type: 'warning'
                }).then(() => {
                    this.govoid()
                }).catch(() => {

                });
            },
            async govoid() {
                this.loading = true;
                let param = {
                    i_mid: this.mid,
                    i_id: this.i_id,
                };
                let res = await API.cancel(param);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.loading = false;
                    this.cancel(1);
                } else if (res.code == -2) {
                    this.loading = false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.loading = false;
                    this.$message.error(res.message);
                }
            },
            tosubmit() {
                //console.log(this.i_fytype,'this.i_fytype')
                //console.log(this.tableData,'this.tableData')
                //console.log(this.i_invoiceType,'this.i_invoiceType')
                //if(this.i_invoiceType==1){
                    if(this.needsave==true){
                        this.$message.error(this.$t('invoiceEntry_please_save_the_edited_information_before_submitting_for_approval'));
                        return;
                    }else{
                        let hejiData = [...this.tableData];
                        const hasCf = hejiData.some(item => item.i_type == 1);
                        if(hasCf){
                            hejiData=hejiData.filter(itemB => itemB.i_type == 1);
                        }
                        //console.log(hejiData,'hejiData')
                        const checkResult = this.validateInvoices(hejiData);
                        //console.log('checkResult',checkResult)
                        if (!checkResult.isValid) {
                            this.$message.error(this.$t('invoiceEntry_there_are_invoice_amounts_that_do_not_match_the_total_order_amount',[checkResult.mismatches.length]));
                            // this.$message.error(`有 ${checkResult.mismatches.length} 条发票金额与订单总额不一致`);
                            return;
                        }
                    }
                //}
                this.$confirm(this.$t('invoiceEntry_are_you_sure_to_submit_for_approval'), this.$t('tips_prompt'), {
                    confirmButtonText: this.$t('button_sure'),
                    cancelButtonText: this.$t('button_cancel'),
                    type: 'warning'
                }).then(() => {
                    this.submit();
                }).catch(() => {

                });
            },
            async submit() {
                this.loading = true;
                let param = {
                    i_mid: this.mid,
                    i_id: this.i_id,
                };
                //console.log(param, 'param')
                //return;
                let res = await API.submit(param);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.loading = false;
                    this.cancel(1);
                } else if (res.code == -2) {
                    this.loading = false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.loading = false;
                    this.$message.error(res.message);
                }
            },
            refreshTable() {
                this.showTable = false;
                this.$nextTick(() => {
                    this.showTable = true;
                })
            },
            //处理关联量
            handleRelevancenum(type) {
                /*let mul = this.multipleSelection.length;
                let tab = this.tableData.length;
                console.log(mul, 'mul')
                console.log(tab, 'tab')
                if (mul > 0) {
                    let arr = [];
                    let totalgl = 0;
                    this.multipleSelection.map(item => {
                        item.details.map(subitem => {
                            totalgl += subitem.f_syglfpnum;
                            subitem.f_syglfpnum2 = subitem.f_syglfpnum;
                            subitem.f_glnum = 0;
                            //subitem.f_glpay = 0;
                            arr.push(subitem)
                        })
                    });
                    this.pzdetails = arr;
                    this.totalgl = parseFloat(this.keepTwoDecimal(totalgl));
                    console.log('累计可关联量', totalgl);
                    console.log('订单品种details', this.pzdetails);
                    this.tableData.map(item => {
                        item.i_id = 0;
                        item.f_num = 0;
                        item.details = arr;
                    })
                }
                if (mul == 0) {
                    let somekong = this.tableData.some(item => {
                        return !item.details || item.details.length == 0
                    })
                    console.log('somekong', somekong)
                    if (somekong) {
                        let kongData = this.tableData.filter(item => {
                            return !item.details || item.details.length == 0
                        })
                        console.log('kongData', kongData)
                        kongData.map(kongitem => {
                            let idx = this.tableData.findIndex(item => {
                                return item.i_pzid == kongitem.i_pzid && (item.details.length == 0 || !item.details)
                            })
                            let idx2 = this.tableData.findIndex(item => {
                                return item.i_pzid == kongitem.i_pzid && (item.details.length > 0)
                            })
                            console.log('idx', idx, 'idx2', idx2)
                            if (idx2 != -1) {
                                let newdetails = this.deepClone(this.tableData[idx2].details);
                                newdetails.map(item => {
                                    item.f_glnum = 0;
                                    item.f_syglfpnum = item.f_syglfpnum2;
                                })
                                this.tableData[idx].details = newdetails;
                            } else {
                                if (this.pzdetails.length != 0) {
                                    console.log('订单品种details', this.pzdetails);
                                    let newdetails = this.pzdetails.filter(item => {
                                        return item.i_pzid == this.tableData[idx].i_pzid
                                    })
                                    this.tableData[idx].details = newdetails;
                                }

                            }
                        })
                    }
                }
                if (type == 'pl') {
                    this.plConnectnum();
                }
                console.log(this.tableData, 'this.tableData-handle')*/
            },

            cancelDialog_order(val) {
                /*this.dialogVisible_order = false;
                if (val) {
                    this.tableData.map(item => {
                        if (item.i_id != 0) {
                            this.delIds.push(item.i_id)
                        }
                    })
                    console.log(this.delIds, 'this.delIds----');
                    this.tableData = this.details_ord;
                    this.detmx = [];
                    console.log(this.details_ord, 'details_ord-old')
                    //还原拆分数据
                    this.tableData.map(item => {
                        if (item.i_type == 0) {
                            item.i_type = 1;
                            item.vc_hs_fkey_sub = null;
                            item.i_pzid = 0;
                            item.vc_pzname = '';
                            item.vc_bzstyle = '';
                            item.vc_cd = '';
                            item.vc_gykh = '';
                            item.vc_unit = '';
                            item.f_num = 0;
                            item.f_pay = 0;
                            item.f_pay_gs = 0;
                            item.f_pay_ws = 0;
                            item.f_pay_yb = 0;
                            item.f_pay_zzs = 0;
                            item.f_price_ws = 0;
                            item.f_rate = 0;
                            item.f_syglfpnum = 0;
                            item.kyfpnum = 0;
                        }
                    })
                    if (this.i_fytype != 1) {  //非运输
                        console.log(val, 'valthis.i_fytype!=1')
                        this.i_bzid_yb = val.i_bzid_yb;
                        this.orderWs = val.orderWs;
                        this.orderids = val.ids;
                        //this.disselect=val.ids;
                        this.flagpzList = val.details;
                        this.multipleSelection = val.multipleSelection;
                        if (this.i_isfrom == 0 && this.i_flag == 1) {
                            let details = this.deepClone(val.details);
                            console.log(details, '无品种进口')
                            console.log(this.details_form, 'form');
                            details.map(item => {
                                item.visible = false;
                                item.kyfpnum = 0;
                                item.f_num = 0;
                                item.f_price_ws = 0;
                                item.f_pay_zzs = 0;
                                item.f_pay_gs = 0;
                                item.f_pay_ws = 0;
                                item.f_rate = 1;
                                item.f_sl = this.details_form.f_sl;
                                item.f_sl_gs = this.details_form.f_sl_gs;
                                item.i_type = 1;
                            })
                            this.tableData = details;
                        }
                        if (this.i_isfrom == 1 && this.i_flag == 1) {
                            this.beforedetail(this.details_form);
                            return;
                        }
                        this.handleRelevancenum('pl')
                    }
                    if (this.i_fytype == 1) {
                        console.log('运输this.i_fytype==1', val)
                        this.selectD = val.details;
                        this.i_bzid_yb = val.i_bzid_yb;
                        this.orderWs = val.orderWs;
                        this.orderids = val.ids;
                        //this.disselect=val.ids;
                        //this.pickorderlist= this.deepClone(val.details);//带选择订单的数据
                        console.log(this.i_isfrom, 'this.i_isfrom');
                        //console.log(this.pickorderlist,'this.pickorderlist');
                        if (this.i_isfrom == 0) {
                            console.log('发票无details')
                            /!*val.details.map((item,index)=>{
                                item.vc_pzname=this.vc_type;
                                item.vc_cd='';
                                item.vc_gykh='';
                                item.vc_bzstyle='';
                                let chu = 1+this.f_sl;
                                let payws = this.preciseDiv(item.f_sqpay_total, chu);
                                //payws = parseFloat(this.keepTwoDecimal(payws));
                                item.f_pay_ws = payws;
                                item.f_sl=this.f_sl;
                                let fzzs = item.f_pay_ws * this.f_sl;
                                //fzzs = parseFloat(this.keepTwoDecimal(fzzs));
                                item.f_pay_zzs = fzzs;
                                item.i_id = 0;
                                item.i_type=1;
                                item.selectedVarieties=[];
                                item.index=index
                            });
                            this.tableData=val.details;*!/
                            this.tableData = [];
                            let map = {
                                vc_pzname: this.vc_type,
                                f_sl: this.details_form.f_sl,
                                f_pay_ws: this.details_form.f_pay_ws,
                                f_pay_zzs: this.details_form.f_pay_zzs,
                                vc_fppzname: '运输',
                                i_id: 0,
                                i_type: 1,
                                details: [],
                                index: 0
                            };
                            this.tableData.push(map);
                            this.refreshTable();
                            /!*!//价税合计(付款申请总金额
                            let sqtotal = 0;
                            this.tableData.map(item=>{
                                sqtotal += item.f_sqpay_total;
                            })
                            let num = parseFloat(this.keepTwoDecimal(sqtotal));
                            this.sqtotalPrice = this.returnFloat(num);
                            this.DtotalPrice = this.convertToChineseCapital(this.sqtotalPrice);*!/
                        } else {
                            console.log('发票有details');
                            /!*!//价税合计(付款申请总金额
                            let sqtotal = 0;
                            val.details.map(item=>{
                                sqtotal += item.f_sqpay_total;
                            });
                            let num = parseFloat(this.keepTwoDecimal(sqtotal));
                            this.sqtotalPrice = this.returnFloat(num);
                            this.DtotalPrice = this.convertToChineseCapital(this.sqtotalPrice);*!/
                            let data = this.deepClone(this.details_ord)
                            data.map((item, index) => {
                                item.vc_pzname = this.vc_type;
                                item.f_num = item.f_fpnum;
                                item.f_bcfpnum = item.f_fpnum;//本次发票数量
                                item.unit = 'no';
                                item.f_pay_ws = item.f_fppay_ws;
                                item.f_pay_zzs = item.f_fppay_zzs;
                                item.i_id = 0;
                                item.i_type = 1;
                                item.details = [];
                                item.index = index
                            });
                            this.tableData = data;
                        }
                    }
                }*/
            },
            goconnect() {
                this.dataConnect = {
                    i_id: this.i_id,
                    i_fytype: this.i_fytype,
                }
                this.dialogVisible_connect = true;
            },
            cancelDialog_connect() {
                this.dialogVisible_connect = false;
            },
            cancelDialog_mx(val) {
                this.dialogVisible_mx = false;
                if (val) {
                    this.tableData = val.data;
                    this.save();
                }
            },
            goOrder(data, index, row) {
                //console.log('row', row)
                //console.log('this.xsComId', this.xsComId)
                //console.log('this.i_kpkhid', this.i_kpkhid)
                /*if (this.isred == true) {
                    return;
                }*/
                /*if(this.i_id!=0&&this.i_checkstate!='0'){
                    return;
                }*/
                if (this.i_kpkhid == 0) {
                    this.$message.error(this.$t('invoiceEntry_please_select_the_invoicing_party')+'!');
                    return;
                }
                if (this.companyId == 0) {
                    this.$message.error(this.$t('invoiceEntry_please_select_the_buyer')+'!');
                    return;
                }
                if (this.i_isagent == 1 && this.xsComId == 0) {
                    this.$message.error(this.$t('invoiceEntry_please_select_the_seller')+'!');
                    return;
                }
                if (this.isred && this.formData.vc_fpcode == '') {
                    this.$message.error(this.$t('invoiceEntry_for_red_letter_invoices_please_select_the_associated_invoice_first_then_choose_the_order')+'!');
                    return;
                }

                //this.currentInvoiceId = index;
                this.currentInvoiceId = row.localId;
                const row2 = this.tableData.find(i => i.localId === this.currentInvoiceId);
                //console.log(row,'row2')
                this.dataOrd = {
                    i_id: this.i_id,
                    i_isfrom: this.i_isfrom,
                    index: index,
                    row: row2,
                    i_kpkhid: this.i_isagent == 1 ? this.xsComId : this.i_kpkhid,
                    i_gsid: this.companyId,
                    i_issd: this.i_issd,
                    i_flag: this.i_flag,
                    vc_fymx: this.vc_fymx,
                    i_fytype: this.i_fytype,
                    i_type: this.i_type,
                    varieties: this.selectD,
                    invoices: this.tableData,
                    i_checkstate: this.i_checkstate,
                    maxDialogHeight:this.maxDialogHeight,
                    isred:this.isred,
                    i_glfpid:this.i_glfpid,
                    //dt_fptime:this.formData.dt_fptime.split(' ')[0],
                };
                this.dialogVisible_order = true;
            },
            //点击事件
            download(e) {
                let inc = this.vc_newname.includes('http');
                let url = inc ? this.vc_newname : this.file_root + this.vc_newname;
                //console.log(url, 'url')
                window.open(url, '_blank')
                //window.location.href = this.vc_newname;
                //window.open(this.file_url+'param='+encodeURI('{app:\''+this.baseApp+'\',i_uid:\''+this.i_uid+'\',token:\''+this.token+'\',version:\''+this.baseVersion+'\',fid:\''+this.vc_newname+',invoice\'}','utf-8'))
            },
            clearFile(val, index) {
                this.formData.files.splice(index, 1);
                this.vc_newname = '';
                this.loading = true;
                //this.formData.vc_files.otherfiles.splice(index,1)
                // this.formData.vc_files.otherfiles=[]
                this.$forceUpdate()
            },
            async uploadFile(e) {
                let that = this;
                let i = 0;
                let $files = e.target.files[0];
                let fileName = $files.name;
                let type = $files.type;
                var list = {
                    "image/jpeg": true,
                    "image/png": true,
                    "image/jpg": true,
                    "image/bmp": true,
                    "application/pdf": true
                };
                let result = list[type];
                if (($files && result == false) || ($files && result == undefined)) {
                    that.$message.error(that.$t('tips_please_upload_a_file_with_the_correct_format'));
                    return;
                }
                ;
                if ($files) {
                    that.fileName = $files.name;
                    that.fileType = $files.type;
                    that.fileUrl = window.URL.createObjectURL(e.target.files[0]);
                } else {
                    that.fileName = "";
                    that.fileType = "";
                    that.fileUrl = "";
                }
                if (that.fileName) {
                    var fileId = 'uploadfile' + that.idNum;
                    var param = {
                        // "file": fileId,
                        // "fileName": that.fileName,
                        // "IDtype": "",
                        // "type": 1,
                        "style": "invoicepool",
                        "files": $files,
                        //"token":sessionStorage.getItem("token"),
                        //"app": "dsmanage",
                        "vc_app": "invoicepool",
                        "i_appid": 0,
                        // "version": "1.0",
                        // "i_uid": sessionStorage.getItem("userid"),
                        "vc_lruname": sessionStorage.getItem("lruname"),
                        "i_lruid": sessionStorage.getItem("userid"),
                        // "i_mid": this.mid
                    };
                    let FD = new FormData();
                    for (let key in param) {
                        FD.append(key, param[key])
                    }
                    let res = await API.upload(param);
                    if (res.code == 1) {
                        // this.filesImgList.push(res.data[0])
                        // this.filesList.push(res.data[0].i_id)
                        let file = {
                            i_id: res.data[0].i_id,
                            vc_name: res.data[0].filename,
                            vc_newname: res.data[0].filenewname,
                            vc_path: res.data[0].vc_path
                        }
                        /*this.formData.vc_files.otherfiles.push(file)*/
                        this.formData.files.push(file);
                        this.vc_newname = res.data[0].vc_path;
                        //console.log(this.vc_newname, 'this.vc_newname')
                        this.loading = false;
                        this.$forceUpdate()
                    } else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    } else {
                        this.$message.error(res.message);
                    }
                }
            },
            resetnote() {
                //console.log(this.copynote,this.copyfpcode,this.formData.vc_fpcode,'123---')
                this.formData.vc_note = this.copynote + ';'+this.$t('invoiceEntry_invoice_number_with_red_and_blue_characters')+':' + this.copyfpcode + ';'+this.$t('invoiceEntry_red_invoice_information_confirmation_form_number')+':' + this.formData.vc_fpcode;
            },
            cancelDialog_fpcnew(val) {
                //console.log('val', val)
                this.dialogVisible_fpcnew = false;
                this.refreshTable();
                if (val) {
                    if (this.i_id == 0 && this.isred == false) {
                        //console.log('清空')
                        this.tableData = [];
                        this.orderWs = '';
                        this.orderids = [];
                        this.pickorderlist = [];
                    }
                    this.i_isfrom = val.i_isfrom;
                    this.vc_fkey = val.form.vc_fkey;
                    //console.log('this.i_isfrom', this.i_isfrom)
                    if (val.name == 'add') {
                        if (this.i_isfrom == 1) {
                            this.isbtn = true;
                            this.details_form = val.form;
                            this.details_ord = val.form.details;
                            this.vc_newname = val.form.vc_mainfile_newname;
                            this.filesfp = val.form.files;
                            this.formData.vc_fpcode = val.form.vc_fpcode;
                            this.formData.dt_fptime = val.form.dt_fptime;
                            this.fptotalPrice = val.form.f_pay;
                            this.totalPrice = val.form.f_pay;
                            this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);
                            this.beforedetail(val.form);
                        } else {
                            this.isbtn = false;
                            this.details_form = val.form;
                            this.details_ord = val.form.details;
                            this.vc_newname = val.form.vc_mainfile_newname;
                            this.filesfp = val.form.files;
                            this.formData.vc_fpcode = val.form.vc_fpcode;
                            this.formData.dt_fptime = val.form.dt_fptime;
                            this.formData.dt_cwtime = val.form.dt_fptime;
                            this.fptotalPrice = val.form.f_pay;
                            this.totalPrice = val.form.f_pay;
                            this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);
                            this.nodetail(val.form)
                        }
                    } else if (val.name == 'spill') {
                        //console.log('spill',val)
                        this.i_invoiceType = '2';
                        this.vc_newname = val.form.vc_mainfile_newname;
                        this.filesfp = val.form.files;
                        this.formData.vc_fpcode = val.form.vc_fpcode;
                        this.formData.dt_fptime = val.form.dt_fptime;
                        this.formData.dt_cwtime = val.form.dt_fptime;
                        if(this.i_id!=0) {
                            this.copyfpcode = this.vc_relateinvoice_code
                            this.copynote = this.formData.vc_note.split(";")[0];
                        }
                        this.formData.vc_note = this.copynote + ';'+this.$t('invoiceEntry_invoice_number_with_red_and_blue_characters')+':' + this.copyfpcode  + ';'+this.$t('invoiceEntry_red_invoice_information_confirmation_form_number')+':' + this.formData.vc_fpcode;
                        this.spillfppay = val.form.f_pay;
                    }
                } else {
                    //this.i_isfrom=1;
                    if (this.isred) {
                        this.isred = false;
                        this.i_invoiceType = '1';
                        this.i_id = this.Data.row.i_id;
                        this.detail()
                    }
                }
            },
            nodetail(form) {
                console.log(form,'form---')
                this.tableData = [];
                let map = {
                    vc_pzname: this.i_fytype == 1 ? this.vc_type : '',
                    vc_fppzname: this.i_fytype == 1 ? this.vc_type : '',
                    f_fppay_ws:form.f_pay_ws,
                    f_fppay_zzs:form.f_pay_zzs,
                    vc_fpbzstyle:'',
                    vc_fpunit:'',
                    f_fpnum:'',
                    f_fpprice:'',
                    f_pay_ws: form.f_pay_ws,
                    f_pay_zzs: form.f_pay_zzs,
                    f_pay: form.f_pay_ws + form.f_pay_zzs,
                    f_sl: form.f_sl,
                    f_sl_gs: this.i_flag == 1 ? form.f_sl_gs : 0,
                    f_pay_gs: this.i_flag == 1 ? form.f_pay_gs : 0,
                    f_rate: this.i_flag == 1 ? 1 : null,
                    i_id: 0,
                    i_type: 1,
                    details: [],
                    index: 0,
                    localId: `invoice_${Date.now()}_${0}`,
                    i_isdiffer:1,
                };
                this.tableData.push(map);
                this.refreshTable();
            },
            async beforedetail(form) {
                /*this.tableData.map(item=>{
                    if(item.i_id!=0&&item.i_id){
                        this.delIds.push(item.i_id)
                    }
                })
                console.log('this.delIds',this.delIds);*/
                let form1 = this.deepClone(form)
                //console.log('formmmmmmmmmm', form1)
                this.disinput_fpcode = true;
                this.disinput = true;
                this.disinput2 = false;
                form1.details.map((item, index) => {
                    item.index = index;
                    item.visible = false;
                    item.vc_pzname = this.i_fytype == 1 ? this.vc_type : "";
                    item.f_num = item.f_fpnum;
                    item.f_bcfpnum = item.f_fpnum;//本次发票数量
                    item.f_price_ws = item.f_fpprice;
                    item.f_pay_ws = item.f_fppay_ws;
                    item.f_pay_zzs = item.f_fppay_zzs;
                    item.f_pay = item.f_pay_ws + item.f_pay_zzs;
                    item.f_rate = 1;
                    item.i_type = 1;
                    item.details = [];
                    item.i_id = 0;
                    item.localId=`invoice_${Date.now()}_${index}`;
                    item.i_isdiffer=1;
                })
                this.tableData = form1.details;
                this.formData = form1;
                this.formData.dt_cwtime = form1.dt_fptime;
                //console.log('this.tableData--',this.tableData);
                //console.log('this.formData',this.formData);
                this.i_id = form1.i_id;
                this.vc_fkey = form1.vc_fkey;
                this.fptotalPrice = form1.f_pay;
                this.totalPrice = form1.f_pay;
                //this.DtotalPrice=form1.vc_capitalpay;
                this.DtotalPrice = this.convertToChineseCapital(form1.f_pay);
                this.f_pay_ws = form1.f_pay_ws;
                this.f_pay_zzs = form1.f_pay_zzs;
                this.yuanshi = this.deepClone(this.tableData).filter(item => (item.vc_pzname == ''))
                //console.log(this.yuanshi, 'yuanshi')
                this.vc_newname = form1.vc_mainfile_newname;
                /*if (this.i_fytype != 1) {
                    this.handleRelevancenum();
                }*/
            },

            //获取详情
            async detail() {
                this.loading = true;
                let param = {
                    i_id: this.i_id,
                    vc_fkey: '',
                    //isover:this.isover,
                    i_gsid:this.i_gsid,
                    i_kpkhid:this.i_kpkhid,
                    i_isnew:1,
                    i_checkstate:8,
            };
                let res = await API.detail(param);
                if (res.code == 1) {
                    this.disinput_fpcode = true;
                    this.disinput = true;
                    this.disinput2 = true;
                    this.i_isfrom = res.data.i_isfrom;
                    this.formData = res.data;
                    this.tableData = res.data.details;
                    this.i_id = res.data.i_id;
                    this.copyfpcode = res.data.vc_fpcode;
                    if (res.data.i_isfrom == 1) {
                        this.isbtn = true
                    }
                    res.data.details.map((item, index) => {
                        item.visible = false;
                        item.f_sl_gs = res.data.f_sl_gs;
                        item.index = index;
                        item.localId=`invoice_${Date.now()}_${index}`;
                    })
                    if (this.i_isfrom == 1) {
                        //存初始this.details_ord
                        let csarr = this.deepClone(res.data.details);
                        let hash = {};
                        csarr = csarr.reduce(function (item, next) {
                            hash[next.vc_fkey_sub] ? '' : hash[next.vc_fkey_sub] = true && item.push(next);
                            return item
                        }, []);
                        //console.log("csarr", csarr);
                        csarr.map(item => {
                            item.details = [];
                            item.f_num = 0;
                            item.f_pay = 0;
                            item.f_pay_ws = 0;
                            item.f_pay_yb = 0;
                            item.f_pay_zzs = 0;
                            item.f_price = 0;
                            item.f_price_ws = 0;
                            item.f_price_yb = 0;
                            item.i_fpid = 0;
                            item.i_pzid = 0;
                            item.kyfpnum = 0;
                            item.totalpzglnum = 0;
                            item.vc_bzstyle = '';
                            item.vc_bzsymbol = '';
                            item.vc_cd = '';
                            item.vc_gykh = '';
                            item.vc_pzname = '';
                            item.vc_unit = '';
                        })
                        this.details_ord = csarr;
                    } else {
                        this.details_ord = [];
                    }
                    let mxarr = [];
                    res.data.details.map(item => {
                        item.details.map(subitem => {
                            mxarr.push(subitem)
                            subitem.f_syglfpnum2 = subitem.f_syglfpnum
                            subitem.vc_fkey_sub = item.vc_fkey_sub
                            subitem.kyfpnum = item.kyfpnum
                            subitem.totalpzglnum = item.totalpzglnum
                        })
                    })
                    this.detmx = mxarr;
                    this.details_form = res.data;
                    this.details_form.details = this.details_ord;
                    //console.log(this.details_form, 'this.details_form')
                    this.i_checkstate = res.data.i_checkstate;
                    this.totalPrice = res.data.f_pay;
                    this.fptotalPrice = res.data.f_pay;
                    this.DtotalPrice = res.data.vc_capitalpay;
                    this.spillfppay = res.data.f_pay;
                    //this.DtotalPrice=this.convertToChineseCapital(res.data.f_pay);
                    this.f_pay_ws = res.data.f_pay_ws;
                    this.f_pay_zzs = res.data.f_pay_zzs;
                    this.i_isagent = res.data.i_isagent;
                    this.isdk = res.data.i_dkable;
                    this.companyName = res.data.vc_gsname;
                    this.companyId = res.data.i_gsid;
                    this.vc_gscreditcode = res.data.vc_gscreditcode;
                    this.lastCheckOutDate = res.data.lastCheckoutDate;
                    this.xsComname = res.data.i_isagent == 1 ? res.data.vc_kpkhname : '';
                    this.xsComId = res.data.i_isagent == 1 ? res.data.i_kpkhid : 0;
                    this.i_kpkhid = res.data.i_isagent == 1 ? res.data.i_dlkhid : res.data.i_kpkhid;
                    this.vc_kpkhname = res.data.i_isagent == 1 ? res.data.vc_dlkhname : res.data.vc_kpkhname;
                    this.vc_khcreditcode = res.data.vc_khcreditcode;
                    this.i_type = res.data.i_type;
                    this.vc_type = res.data.typeTxt;
                    this.i_fptype = res.data.i_fptype;
                    this.vc_fptype = res.data.vc_fptype;
                    this.vc_newname = res.data.vc_mainfile_newname;
                    let files = [];
                    let arr = res.data.vc_mainfile_newname.split(';')
                    arr.map((subitem, subindex) => {
                        let map = {}
                        map.vc_mainfile_newname = subitem;
                        map.vc_filename = res.data.vc_fpcode + '_' + subindex;
                        files.push(map)
                    })
                    this.filesfp = files;
                    //console.log(this.filesfp,'filesfp')
                    this.orderWs = res.data.vc_no;
                    this.orderids = res.data.vc_no.split(',');
                    //this.disselect=res.data.vc_no.split(',');
                    //console.log(this.disselect)
                    this.i_origin_khtype = res.data.i_origin_khtype;
                    this.vc_fymx = res.data.vc_fymx;
                    this.i_issd = res.data.i_issd;
                    this.i_flag = res.data.i_flag;
                    this.i_invoiceType = res.data.i_invoiceType;
                    this.isred=res.data.i_invoiceType==2?true:false;
                    this.reverseId=res.data.reverseId;
                    this.vc_relateinvoice_code = res.data.vc_relateinvoice_code ? res.data.vc_relateinvoice_code : null;
                    this.i_glfpid = res.data.i_invoiceType==2?res.data.i_glfpid:res.data.i_id;
                    this.i_bzid_yb = res.data.i_bzid_yb;
                    this.i_fytype = res.data.i_fytype;
                    this.vc_fkey = res.data.vc_fkey;
                    /*this.fpData={
                        name:'spill',
                        i_isfrom:res.data.i_isfrom,
                        i_type:res.data.i_type,
                        vc_type:res.data.typeTxt,
                        i_kpkhid:res.data.i_kpkhid,
                        vc_kpkhname:res.data.vc_kpkhname,
                        vc_khcreditcode:res.data.vc_khcreditcode,
                        companyId:res.data.i_gsid,
                        companyName:res.data.vc_gsname,
                        vc_gscreditcode:res.data.vc_gscreditcode,
                    }*/
                    //console.log(this.tableData, 'tableData-----------')
                    if (this.i_fytype != 1) {
                        //赋值订单
                        let arr = [];
                        let totalgl = 0;
                        res.data.orderList.map(item => {
                            item.details.map(subitem => {
                                totalgl += subitem.f_syglfpnum;
                                subitem.f_syglfpnum2 = subitem.f_syglfpnum;
                                subitem.f_glnum = 0;
                                //subitem.f_glpay = 0;
                                arr.push(subitem)
                            })
                        });
                        this.pzdetails = arr;
                        if (this.i_flag == 1) {
                            this.flagpzList = arr;
                        }
                        //处理发票数量
                        let vc_fkey_sub = this.tableData[0].vc_fkey_sub ? this.tableData[0].vc_fkey_sub : '';
                        let other = this.tableData.filter(item => {
                            return item.vc_fkey_sub != vc_fkey_sub
                        })
                        //console.log('other', other)
                        if (other.length > 0) {
                            let hash = {};
                            other = other.reduce(function (item, next) {
                                hash[next.vc_fkey_sub] ? '' : hash[next.vc_fkey_sub] = true && item.push(next);
                                return item
                            }, []);
                            //console.log("other--", other);
                            this.fp_num = 0;
                            other.map(otheritem => {
                                this.fp_num += otheritem.kyfpnum
                            })
                            this.fp_num = this.fp_num + this.tableData[0].kyfpnum;
                            this.fp_num = parseFloat(this.keepTwoDecimal(this.fp_num));
                            //console.log('this.fp_num', this.fp_num)
                        } else {
                            this.fp_num = 0;
                            this.fp_num = this.tableData[0].kyfpnum;
                            this.fp_num = parseFloat(this.keepTwoDecimal(this.fp_num));
                            //console.log('this.fp_num', this.fp_num)
                        }
                    }
                    this.updateTableHeight();
                    window.addEventListener('resize', this.updateTableHeight);
                    this.loading = false;
                } else if (res.code == -2) {
                    this.loading = false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.loading = false;
                    this.$message.error(res.message);
                }
            },
            sepay(data, index, row) {
                let cenzzs = row.f_pay_ws * row.f_sl;
                cenzzs = parseFloat(this.keepTwoDecimal(cenzzs));
                //console.log(cenzzs, 'cenzzs')
                let more = cenzzs + 1;
                let less = cenzzs - 1;
                //console.log(more, 'more')
                //console.log(less, 'less')
                if (row.f_pay_zzs < less || row.f_pay_zzs > more) {
                    this.$nextTick(() => {
                        row.f_pay_zzs = cenzzs;
                    })
                    this.$message.error(this.$t('invoiceEntry_the_tax_amount_must_not_exceed_or_be_less_than_the_established_tax_amount_by_more_than') + cenzzs + "±1！");
                }
                this.$nextTick(() => {
                    //价税合计
                    let tp = 0;
                    let ts = 0;
                    data.map(item => {
                        tp += item.f_pay_ws;
                        ts += item.f_pay_zzs;
                    });
                    this.f_pay_ws = parseFloat(this.keepTwoDecimal(tp));
                    this.f_pay_zzs = parseFloat(this.keepTwoDecimal(ts));
                    let num = this.keepTwoDecimal(tp + ts);
                    this.totalPrice = this.returnFloat(num);
                    this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);
                })
                this.needsave=true
                this.InvoiceChange(row);
            },
            infrate(data, index, row) {
                //console.log(row.f_price_ws, 'f_price_ws')
                //console.log(row.f_price_yb, 'f_price_yb')
                let payws = row.f_pay_ws - row.f_pay_gs;
                //console.log(payws, '完税-关税')
                let price = this.preciseDiv(payws, row.f_num);
                price = parseFloat(price);
                price = parseFloat(price.toFixed(8));
                row.f_price_ws = price;
                let price_yb = this.preciseDiv(price, row.f_rate);
                row.f_price_yb = price_yb;
                this.$set(data, index, row);
                //价税合计
                let tp = 0;
                let ts = 0;
                data.map(item => {
                    tp += item.f_pay_ws;
                    ts += item.f_pay_zzs;
                })
                this.f_pay_ws = parseFloat(this.keepTwoDecimal(tp));
                this.f_pay_zzs = parseFloat(this.keepTwoDecimal(ts));
                let num = this.keepTwoDecimal(tp + ts);
                this.totalPrice = this.returnFloat(num);
                this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);
            },
            infsl(data, index, row) {
                if (this.i_isfrom == 1 && row.f_fpnum == 0) {
                    return
                }
                let fzzs = row.f_pay_ws * row.f_sl;
                fzzs = parseFloat(this.keepTwoDecimal(fzzs));
                row.f_pay_zzs = fzzs;
                this.$set(data, index, row);
                //价税合计
                let tp = 0;
                let ts = 0;
                data.map(item => {
                    tp += item.f_pay_ws;
                    ts += item.f_pay_zzs;
                });
                this.f_pay_ws = parseFloat(this.keepTwoDecimal(tp));
                //console.log(this.f_pay_ws)
                this.f_pay_zzs = parseFloat(this.keepTwoDecimal(ts));
                //console.log(this.f_pay_zzs)
                let num = this.keepTwoDecimal(tp + ts);
                this.totalPrice = this.returnFloat(num);
                //console.log(this.totalPrice);
                this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);
                this.needsave=true
                this.InvoiceChange(row);
            },
            inbcfnum(data, index, row) {
                if(this.isred){
                    if (row.f_bcfpnum >= 0 || (Math.abs(row.f_bcfpnum)>Math.abs(row.f_fpnum))) {
                        row.f_bcfpnum = row.f_fpnum;
                        this.$message.error('冲红发票数量请输负数且数量绝对值不可大于发票数量绝对值！')
                        //this.refreshTable();
                        //return;
                    }
                    //else {
                        //冲红发票录入数量改金额 单价不变20260407
                        let payws = parseFloat(this.keepTwoDecimal(row.f_bcfpnum * row.f_price_ws));
                        row.f_pay_ws = payws;
                        let fzzs = parseFloat(this.keepTwoDecimal(row.f_pay_ws * row.f_sl));
                        row.f_pay_zzs = fzzs;
                        row.details=[];
                        row.vc_pzname='';
                        this.$set(data, index, row);
                        //价税合计
                        let tp = 0;
                        let ts = 0;
                        data.map(item => {
                            tp += item.f_pay_ws;
                            ts += item.f_pay_zzs;
                        });
                        this.f_pay_ws = parseFloat(this.keepTwoDecimal(tp));
                        this.f_pay_zzs = parseFloat(this.keepTwoDecimal(ts));
                        let num = this.keepTwoDecimal(tp + ts);
                        this.totalPrice = this.returnFloat(num);
                        this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);
                        this.refreshTable();
                    //}
                }else{
                    //console.log('row',row)
                    if (row.f_bcfpnum <= 0) {
                        row.f_bcfpnum = row.f_fpnum;
                        this.$message.error(this.$t('invoiceEntry_the_quantity_must_not_be_less_than_or_equal_to_0'));
                        this.refreshTable();
                        return;
                    }else{
                        //录入数量改单价 金额不变20251222
                        row.f_price_ws = this.preciseDiv(row.f_pay_ws, row.f_bcfpnum);
                        row.f_price = row.f_price_ws*(1+row.f_sl);
                        row.details=[];
                        row.vc_pzname='';
                        this.$set(data, index, row);
                        /*if (row.unit == 'no') {
                            let bl = 1;
                            //console.log(bl, 'bl----')
                            row.f_num = this.preciseDiv(row.f_bcfpnum, bl);
                            this.$set(data, index, row);
                            this.$nextTick(() => {
                                this.infnum(data, index, row);
                            })
                        } else {
                            let bl = this.preciseDiv(row.f_fpnum, row.kyfpnum);
                            bl = parseFloat(bl);
                            //console.log(bl, 'bl----')
                            row.f_num = this.preciseDiv(row.f_bcfpnum, bl);
                            //row.f_price_ws = bl*row.f_fpprice;
                            this.$set(data, index, row);
                            this.$nextTick(() => {
                                this.infnum(data, index, row);
                            })
                        }*/

                    }
                }
                this.needsave=true
            },
            infnum(data, index, row) {
                if (row.f_num < 0) {
                    row.f_num = 0;
                    this.$message.error(this.$t('invoiceEntry_the_quantity_cannot_be_less_than_0'));
                    this.refreshTable();
                    return;
                } else {
                    if (this.i_fytype != 1) {
                        if (this.i_isfrom == 1) {
                            if (row.f_fpnum == 0) {
                                return
                            }
                            if (row.f_pay_ws != 0) {
                                //判断单位换算是否成功
                                if (row.unit == 'no') {
                                    let bl = this.preciseDiv(row.f_bcfpnum, row.f_num);
                                    bl = parseFloat(bl);
                                    //console.log(bl, 'bl----判断单位换算bu成功')
                                    row.f_price_ws = bl * row.f_fpprice;
                                    let payws = row.f_num * row.f_price_ws
                                    payws = parseFloat(this.keepTwoDecimal(payws));
                                    row.f_pay_ws = payws;
                                    let fzzs = row.f_pay_ws * row.f_sl;
                                    fzzs = parseFloat(this.keepTwoDecimal(fzzs));
                                    row.f_pay_zzs = fzzs;
                                    if (this.i_flag == 1) {
                                        //关税税率写死1%
                                        let gs = row.f_pay_ws * 0.01
                                        gs = parseFloat(this.keepTwoDecimal(gs));
                                        row.f_pay_gs = gs;
                                    }

                                } else {
                                    let payws = row.f_num * row.f_price_ws
                                    payws = parseFloat(this.keepTwoDecimal(payws));
                                    row.f_pay_ws = payws;
                                    let fzzs = row.f_pay_ws * row.f_sl;
                                    fzzs = parseFloat(this.keepTwoDecimal(fzzs));
                                    row.f_pay_zzs = fzzs;
                                    if (this.i_flag == 1) {
                                        //关税税率写死1%
                                        let gs = row.f_pay_ws * 0.01
                                        gs = parseFloat(this.keepTwoDecimal(gs));
                                        row.f_pay_gs = gs;
                                    }
                                }

                                this.$set(data, index, row);
                                //价税合计
                                let tp = 0;
                                let ts = 0;
                                data.map(item => {
                                    tp += item.f_pay_ws;
                                    ts += item.f_pay_zzs;
                                });
                                this.f_pay_ws = parseFloat(this.keepTwoDecimal(tp));
                                this.f_pay_zzs = parseFloat(this.keepTwoDecimal(ts));
                                let num = this.keepTwoDecimal(tp + ts);
                                this.totalPrice = this.returnFloat(num);
                                this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);
                            }

                        } else {
                            row.details = this.pzdetails;
                            if (row.f_pay_ws != 0) {
                                let price = this.preciseDiv(row.f_pay_ws, row.f_num);
                                price = parseFloat(price);
                                price = parseFloat(price.toFixed(8));
                                row.f_price_ws = price;
                                this.$set(data, index, row);
                                //价税合计
                                let tp = 0;
                                let ts = 0;
                                data.map(item => {
                                    tp += item.f_pay_ws;
                                    ts += item.f_pay_zzs;
                                });
                                this.f_pay_ws = parseFloat(this.keepTwoDecimal(tp));
                                this.f_pay_zzs = parseFloat(this.keepTwoDecimal(ts));
                                let num = this.keepTwoDecimal(tp + ts);
                                this.totalPrice = this.returnFloat(num);
                                this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);
                            }
                            this.connectnum(data, index, row)
                        }
                    } else {
                        if (row.f_pay_ws != 0) {
                            let price = this.preciseDiv(row.f_pay_ws, row.f_num);
                            price = parseFloat(price);
                            price = parseFloat(price.toFixed(8));
                            row.f_price_ws = price;
                            this.$set(data, index, row);
                            //价税合计
                            let tp = 0;
                            let ts = 0;
                            data.map(item => {
                                tp += item.f_pay_ws;
                                ts += item.f_pay_zzs;
                            });
                            this.f_pay_ws = parseFloat(this.keepTwoDecimal(tp));
                            this.f_pay_zzs = parseFloat(this.keepTwoDecimal(ts));
                            let num = this.keepTwoDecimal(tp + ts);
                            this.totalPrice = this.returnFloat(num);
                            this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);
                        }
                    }
                    //console.log('this.tableData--infnum', this.tableData);
                }
            },
            //批量处理关联量
            plConnectnum() {
                //console.log('批量')
                //console.log('总关联量', this.totalgl)
                this.tableData.map((item, index) => {
                    let details = this.deepClone(item.details);
                    //console.log('item.i_pzid', item.i_pzid, 'index', index, 'pldetails', details)
                    let choopz = details.filter(subitem => {
                        return subitem.i_pzid == item.i_pzid;
                    })
                    //console.log('choopz', choopz)
                    let totalpzglnum = 0;
                    choopz.map(pzitem => {
                        totalpzglnum += pzitem.f_syglfpnum
                    })
                    //console.log(totalpzglnum, '可关联量' + item.i_pzid);
                    item.totalpzglnum = totalpzglnum;
                    if (item.f_num > totalpzglnum) {
                        this.$message.error(this.$t('invoiceEntry_the_quantity_cannot_exceed_the_associated_quantity') + totalpzglnum);
                        item.f_num = totalpzglnum;
                        //this.refreshTable();
                        //return ;
                    } else {
                        let choonum = item.f_num;
                        let sypznum = totalpzglnum - item.f_num;
                        //console.log(sypznum, '剩余可关联量' + item.i_pzid);
                    }
                    this.reduceQuantities(choopz, item.f_num);
                    //console.log(choopz, 'choopz------');
                    choopz.map((pzitem, index) => {
                        pzitem.totalpzglnum = totalpzglnum
                        pzitem.f_glnum = pzitem.f_syglfpnum2 - pzitem.f_syglfpnum
                        pzitem.f_glnum = parseFloat(this.keepTwoDecimal(pzitem.f_glnum));
                        pzitem.kyfpnum = item.kyfpnum
                        pzitem.vc_fkey_sub = item.vc_fkey_sub
                    })
                    //console.log(choopz, 'choopz2222222');
                    item.details = choopz;
                    //console.log(this.tableData, 'pltableData-----------')
                })
                this.dataputnum()
            },
            //处理默认值
            dataputnum() {
                //console.log('处理默认值')
                let data = this.deepClone(this.tableData);
                let arr = [];
                data.map(mapitem => {
                    if (arr.length == 0) {
                        arr.push({i_pzid: mapitem.i_pzid, totalpzglnum: mapitem.totalpzglnum, list: [mapitem]})
                    } else {
                        let res = arr.some(item => {
                            if (item.i_pzid == mapitem.i_pzid) {
                                item.list.push(mapitem)
                                return true
                            }
                        })
                        if (!res) {
                            arr.push({i_pzid: mapitem.i_pzid, totalpzglnum: mapitem.totalpzglnum, list: [mapitem]}
                            )
                        }
                    }
                })
                //console.log("arr", arr);
                let list = [];
                arr.map(item => {
                    item.list.map(subitem => {
                        list.push(subitem)
                    })
                })
                //console.log("list--", list)
                list.map(listitem => {
                    let listvalue = listitem.vc_fkey_sub + listitem.i_pzid;
                    let idx = data.findIndex(item => {
                        return item.vc_fkey_sub + item.i_pzid == listvalue
                    })
                    if (idx != -1) {
                        data[idx].details = listitem.details
                    }
                })
                //console.log("data--", data)
                this.tableData = data;
                this.surefpnum()
            },
            //按发票数量确认
            surefpnum() {
                let data = this.deepClone(this.tableData);
                //console.log(data, 'data--surefpnum')
                let arr = [];
                data.map(mapitem => {
                    if (arr.length == 0) {
                        arr.push({
                            vc_fkey_sub: mapitem.vc_fkey_sub,
                            kyfpnum: mapitem.kyfpnum ? mapitem.kyfpnum : 0,
                            list: [mapitem]
                        })
                    } else {
                        let res = arr.some(item => {
                            if (item.vc_fkey_sub == mapitem.vc_fkey_sub) {
                                item.list.push(mapitem)
                                return true
                            }
                        })
                        if (!res) {
                            arr.push({
                                    vc_fkey_sub: mapitem.vc_fkey_sub,
                                    kyfpnum: mapitem.kyfpnum ? mapitem.kyfpnum : 0,
                                    list: [mapitem]
                                }
                            )
                        }
                    }
                })
                //console.log("arr--surefpnum-vc_fkey_sub", arr);
                arr.map(item => {
                    let detarr = [];
                    item.list.map(listitem => {
                        listitem.details.map(detitem => {
                            detitem.kyfpnum = listitem.details[0].kyfpnum
                            detitem.vc_fkey_sub = listitem.details[0].vc_fkey_sub
                            detarr.push(detitem)
                        })
                    })
                    //console.log(detarr, 'detarr')
                    if (detarr.length != 0) {
                        let val = 0;
                        detarr.map(item => {
                            val += item.f_syglfpnum2
                        })
                        if (val < item.kyfpnum) {
                            this.reduceQuantities(detarr, val)
                        } else {
                            this.reduceQuantities(detarr, item.kyfpnum)
                        }
                        //console.log(detarr, 'detarr--')
                        detarr.map((item, index) => {
                            item.f_glnum = item.f_syglfpnum2 - item.f_syglfpnum
                            item.f_glnum = parseFloat(this.keepTwoDecimal(item.f_glnum));
                        })
                        //console.log(detarr, 'detarr---');
                        detarr.map(val => {
                            let idx = item.list.findIndex(listval => {
                                return listval.i_pzid == val.i_pzid
                            })
                            //console.log(idx, "idxxxxx")
                            if (idx != -1) {
                                let pcidx = item.list[idx].details.findIndex(pcitem => {
                                    return pcitem.vc_no == val.vc_no
                                })
                                if (pcidx != -1) {
                                    item.list[idx].details[pcidx] = val
                                }
                            }
                        })
                        //console.log(item.list, 'item.list---');
                    }
                })
                //console.log(arr, 'arrrrrrrr')
                arr.map(arritem => {
                    let arrvalue = arritem.vc_fkey_sub;
                    arritem.list.map(listitem => {
                        let idx = data.findIndex(item => {
                            return listitem.i_pzid + arrvalue == item.i_pzid + item.vc_fkey_sub
                        })
                        if (idx != -1) {
                            //console.log(listitem, 'listitemlistitem')
                            data[idx] = listitem;
                        }
                    })
                })
                //console.log("data--", data);
                let mxarr = [];
                data.map(item => {
                    let fnum = 0;
                    if (item.details.length > 0) {
                        //console.log(item.details, 'item.details')
                        item.details.map(subitem => {
                            mxarr.push(subitem)
                            fnum += subitem.f_glnum
                        })
                        item.f_num = fnum;
                        if (this.i_isfrom == 1) {
                            if (item.f_fpnum == 0) {
                                let bl = this.preciseDiv(item.f_fpnum, item.kyfpnum);
                                bl = parseFloat(bl);
                                item.f_price_ws = bl * item.f_fpprice
                                item.f_pay_ws = item.f_fppay_ws;
                                item.f_pay_zzs = item.f_fppay_zzs;
                                item.f_pay = item.f_pay_ws + item.f_pay_zzs;
                            } else {
                                let bl = this.preciseDiv(item.f_fpnum, item.kyfpnum);
                                bl = parseFloat(bl);
                                item.f_price_ws = bl * item.f_fpprice
                                let payws = item.f_num * item.f_price_ws
                                payws = parseFloat(this.keepTwoDecimal(payws));
                                item.f_pay_ws = payws;
                                let fzzs = item.f_pay_ws * item.f_sl;
                                fzzs = parseFloat(this.keepTwoDecimal(fzzs));
                                item.f_pay_zzs = fzzs;
                            }

                        }
                    }
                })
                //价税合计
                let tp = 0;
                let ts = 0;
                data.map(item => {
                    tp += item.f_pay_ws;
                    ts += item.f_pay_zzs;
                })
                this.f_pay_ws = parseFloat(this.keepTwoDecimal(tp));
                this.f_pay_zzs = parseFloat(this.keepTwoDecimal(ts));
                let num = this.keepTwoDecimal(tp + ts);
                this.totalPrice = this.returnFloat(num);
                this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);
                this.detmx = mxarr;
                //console.log("details明细", this.detmx);
                //console.log("发票总量", this.fp_num);
                //console.log("可关联总量", this.totalgl);
                //console.log("data----", data);
                this.tableData = data;
            },

            //处理关联量
            connectnum(data, index, row) {
                //console.log(index,'inedx-------')
                // console.log('row-处理关联量',row)
                let details = this.deepClone(row.details);
                let choopz = details.filter(item => {
                    return item.i_pzid == row.i_pzid;
                })
                //console.log('choopz', choopz, row.i_pzid)
                let totalpzglnum = 0;
                choopz.map(item => {
                    totalpzglnum += item.f_syglfpnum
                    item.vc_fkey_sub = row.vc_fkey_sub
                    item.kyfpnum = row.kyfpnum
                    item.totalpzglnum = totalpzglnum
                })
                //console.log(totalpzglnum, '可关联量' + row.i_pzid);
                if (row.f_num > totalpzglnum) {
                    row.f_num = 0;
                    this.$message.error(this.$t('invoiceEntry_the_quantity_cannot_exceed_the_associated_quantity') + totalpzglnum);
                    this.$set(data, index, row);
                    //this.refreshTable();
                    //return ;
                } else {
                    let choonum = row.f_num;
                    let sypznum = totalpzglnum - row.f_num;
                    //console.log(sypznum, '剩余可关联量' + row.i_pzid);
                    this.reduceQuantities(choopz, row.f_num);
                    //console.log(choopz, 'choopz------');
                    choopz.map((item, index) => {
                        item.f_glnum = item.f_syglfpnum2 - item.f_syglfpnum
                        item.f_glnum = parseFloat(this.keepTwoDecimal(item.f_glnum));
                    })
                    //console.log(choopz, 'choopz2222222');
                    row.details = choopz
                    this.$set(data, index, row);
                    //console.log('row-last',row)
                    //console.log(this.tableData, 'tableData-----------')
                    //控制相同品种可关联量
                    let tabData = this.deepClone(this.tableData);
                    let rowpz = tabData.filter(tabitem => {
                        return tabitem.i_pzid == row.i_pzid
                    })
                    //console.log(rowpz, '相同品种');
                    let rowpzglnum = 0;
                    rowpz.map(val => {
                        val.details.map(subval => {
                            rowpzglnum += subval.f_glnum
                        })
                    })
                    //console.log(rowpzglnum, '该品种的合计可关联量');
                    //console.log(totalpzglnum, '可关联量');
                    if (rowpzglnum > totalpzglnum) {
                        //console.log(rowpzglnum + '>' + totalpzglnum)
                        this.$message.error(this.$t('invoiceEntry_the_number_of_invoices_for_exceeds_the_number_of_associated_invoices_for_this_variety',[row.vc_pzname + row.vc_cd + row.vc_gykh + row.vc_bzstyle,totalpzglnum]));
                        // this.$message.error(row.vc_pzname + row.vc_cd + row.vc_gykh + row.vc_bzstyle + '的发票数量超过该品种的可关联发票数量' + totalpzglnum);
                    }
                    let mxarr = [];
                    this.tableData.map(item => {
                        item.details.map(subitem => {
                            mxarr.push(subitem)
                        })
                    })
                    this.detmx = mxarr;
                }
            },
            reduceQuantities(items, total) {
                //console.log(items, 'items', total, 'total')
                while (total > 0) {
                    for (let i = 0; i < items.length; i++) {
                        if (items[i].f_syglfpnum > 0) {
                            //console.log(i, 'i')
                            //console.log(items[i].f_syglfpnum, 'items[i].f_num')
                            //console.log(total, 'total')
                            total = parseFloat((total - items[i].f_syglfpnum).toFixed(this.$setPrecision.quantityPrecision));
                            //console.log(total, 'total')
                            if (total === 0) {
                                items[i].f_syglfpnum = 0;
                                //console.log(items[i].f_syglfpnum, 'items[i].f_syglfpnum')
                                //console.log(total, 'total')
                                break;
                            }
                            if (total < 0) {
                                items[i].f_syglfpnum = total * -1;
                                //console.log(items[i].f_syglfpnum, 'items[i].f_syglfpnum')
                                //console.log(total, 'total')
                                break;
                            }
                            //console.log(total, '-------')
                            break;
                            // 继续下一轮减少
                        }
                    }
                }
            },
            paygs(data, index, row) {
                if (row.f_pay_ws != 0) {
                    if (row.f_pay_ws <= row.f_pay_gs) {
                        this.$message.error(this.$t('invoiceEntry_the_taxable_amount_must_be_greater_than_the_customs_duty'));
                        row.f_pay_gs = 0;
                        this.$set(data, index, row);
                        //return ;
                    }
                    //console.log(row.f_price_ws, 'f_price_ws')
                    //console.log(row.f_price_yb, 'f_price_yb')
                    let payws = row.f_pay_ws - row.f_pay_gs;
                    //console.log(payws, '完税-关税')
                    let price = this.preciseDiv(payws, row.f_num);
                    price = parseFloat(price);
                    price = parseFloat(price.toFixed(8));
                    row.f_price_ws = price;
                    //console.log(row.f_price_ws, 'f_price_ws2')
                    let price_yb = this.preciseDiv(price, row.f_rate);
                    row.f_price_yb = price_yb;
                    //console.log(row.f_price_yb, 'f_price_yb2')
                    this.$set(data, index, row);
                    //价税合计
                    let tp = 0;
                    let ts = 0;
                    data.map(item => {
                        tp += item.f_pay_ws;
                        ts += item.f_pay_zzs;
                    })
                    this.f_pay_ws = parseFloat(this.keepTwoDecimal(tp));
                    this.f_pay_zzs = parseFloat(this.keepTwoDecimal(ts));
                    let num = this.keepTwoDecimal(tp + ts);
                    this.totalPrice = this.returnFloat(num);
                    this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);
                }
            },
            infpay(data, index, row) {
                //console.log(row, 'infpay');
                if (this.i_fytype != 1) {
                    if (this.i_isfrom == 1) {
                        let cenzzs = row.f_num * row.f_price_ws;
                        cenzzs = parseFloat(this.keepTwoDecimal(cenzzs));
                        //console.log(cenzzs, 'cenzzs')
                        let more = cenzzs + 1;
                        let less = cenzzs - 1;
                        //console.log(more, 'more')
                        //console.log(less, 'less')
                        if (row.f_pay_ws < less || row.f_pay_ws > more) {
                            this.$nextTick(() => {
                                row.f_pay_ws = cenzzs;
                            })
                            this.$message.error(this.$t('invoiceEntry_the_tax-free_price_must_not_exceed_or_fall_short_of_the_set_price_by_more_than') + cenzzs + "±1！！");
                        }
                        let fzzs = row.f_pay_ws * row.f_sl;
                        fzzs = parseFloat(this.keepTwoDecimal(fzzs));
                        row.f_pay_zzs = fzzs;
                        /*if(this.i_flag==1){
                                //关税税率写死1%
                                let gs =   row.f_pay_ws * 0.01
                                gs = parseFloat(this.keepTwoDecimal(gs));
                                row.f_pay_gs = gs;
                        }*/
                        this.$set(data, index, row);
                        //价税合计
                        let tp = 0;
                        let ts = 0;
                        data.map(item => {
                            tp += item.f_pay_ws;
                            ts += item.f_pay_zzs;
                        })
                        this.f_pay_ws = parseFloat(this.keepTwoDecimal(tp));
                        this.f_pay_zzs = parseFloat(this.keepTwoDecimal(ts));
                        let num = this.keepTwoDecimal(tp + ts);
                        this.totalPrice = this.returnFloat(num);
                        this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);
                    } else {
                        if (this.i_flag == 1) {
                            if (row.f_pay_ws != 0) {
                                if (row.f_pay_ws <= row.f_pay_gs) {
                                    this.$message.error(this.$t('invoiceEntry_the_taxable_amount_must_be_greater_than_the_customs_duty'));
                                    row.f_pay_gs = 0;
                                    //return ;
                                }
                                //console.log(row.f_price_ws, 'f_price_ws')
                                //console.log(row.f_price_yb, 'f_price_yb')
                                let payws = row.f_pay_ws;
                                //console.log(payws, '完税-关税')
                                let price = this.preciseDiv(payws, row.f_num);
                                price = parseFloat(price);
                                price = parseFloat(price.toFixed(8));
                                row.f_price_ws = price;
                                let price_yb = this.preciseDiv(price, row.f_rate);
                                row.f_price_yb = price_yb;
                                let gs = payws * row.f_sl_gs;
                                gs = parseFloat(this.keepTwoDecimal(gs));
                                row.f_pay_gs = gs;
                                let fzzs = payws * row.f_sl;
                                fzzs = parseFloat(this.keepTwoDecimal(fzzs));
                                row.f_pay_zzs = fzzs;
                                //console.log(row, 'gsssssss')
                                this.$set(data, index, row);
                                //价税合计
                                let tp = 0;
                                let ts = 0;
                                data.map(item => {
                                    tp += item.f_pay_ws;
                                    ts += item.f_pay_zzs;
                                })
                                this.f_pay_ws = parseFloat(this.keepTwoDecimal(tp));
                                this.f_pay_zzs = parseFloat(this.keepTwoDecimal(ts));
                                let num = this.keepTwoDecimal(tp + ts);
                                this.totalPrice = this.returnFloat(num);
                                this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);
                            }
                        } else {
                            if (row.f_pay_ws != 0) {
                                let price = this.preciseDiv(row.f_pay_ws, row.f_num);
                                price = parseFloat(price);
                                //console.log(price, 'price');
                                price = parseFloat(price.toFixed(8));
                                row.f_price_ws = price?price:null;
                                let fzzs = row.f_pay_ws * row.f_sl;
                                fzzs = parseFloat(this.keepTwoDecimal(fzzs));
                                row.f_pay_zzs = fzzs;
                                this.$set(data, index, row);
                                //价税合计
                                let tp = 0;
                                let ts = 0;
                                data.map(item => {
                                    tp += item.f_pay_ws;
                                    ts += item.f_pay_zzs;
                                })
                                this.f_pay_ws = parseFloat(this.keepTwoDecimal(tp));
                                this.f_pay_zzs = parseFloat(this.keepTwoDecimal(ts));
                                let num = this.keepTwoDecimal(tp + ts);
                                this.totalPrice = this.returnFloat(num);
                                this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);
                            }
                        }
                    }

                } else {
                    if (row.f_pay_ws != 0) {
                        let price = this.preciseDiv(row.f_pay_ws, row.f_num);
                        price = parseFloat(price);
                        //console.log(price, 'price');
                        price = parseFloat(price.toFixed(8));
                        row.f_price_ws = price;
                        let fzzs = row.f_pay_ws * row.f_sl;
                        fzzs = parseFloat(this.keepTwoDecimal(fzzs));
                        row.f_pay_zzs = fzzs;
                        this.$set(data, index, row);
                        //价税合计
                        let tp = 0;
                        let ts = 0;
                        data.map(item => {
                            tp += item.f_pay_ws;
                            ts += item.f_pay_zzs;
                        })
                        this.f_pay_ws = parseFloat(this.keepTwoDecimal(tp));
                        this.f_pay_zzs = parseFloat(this.keepTwoDecimal(ts));
                        let num = this.keepTwoDecimal(tp + ts);
                        this.totalPrice = this.returnFloat(num);
                        this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);
                    }
                    if(this.isred){
                        row.details=[];
                        row.vc_pzname='';
                        this.$set(data, index, row);
                    }
                }
                this.needsave=true
                this.InvoiceChange(row);
            },
            InvoiceChange(row) {
                const targetLocalId = row.localId;
                const targetInvoice = this.tableData.find(item => item.localId === targetLocalId);
                if (targetInvoice) {
                    if (targetInvoice.details && targetInvoice.details.length > 0) {
                        let dels=[];
                        targetInvoice.details.forEach(item => {
                            if (item.i_id != 0) {
                                dels.push(item.i_id);
                            }
                        });
                        //console.log('dels',dels)
                        this.deletedDataIds=dels;
                        //this.$set(targetInvoice, 'purchaseCwInvoiceIds', dels);
                        this.$set(targetInvoice, 'details', []);
                        this.$message.warning(this.$t('invoiceEntry_the_invoice_information_has_been_modified'));
                    }
                }
            },
            returnFloat(num) {
                num = num.toString(); // 转成字符串类型  如能确定类型 这步可省去
                if (num.indexOf(".") !== -1) {
                    let [integerPart, decimalPart] = num.split(".");

                    if (decimalPart.length > 2) {
                        decimalPart = decimalPart.substring(0, 2);
                    } else if (decimalPart.length === 1) {
                        decimalPart += "0";
                    }

                    num = `${integerPart}.${decimalPart}`;
                } else {
                    num += ".00";
                }

                return num;
            },
            //除
            preciseDiv(dividend, divisor) {
                if (dividend && divisor) {
                    //console.log(dividend, "////", divisor);
                    // 将除数和被除数转换为整数
                    const intDividend = parseFloat(dividend * 1000);
                    const intDivisor = parseFloat(divisor * 1000);
                    // 执行除法
                    const result = intDividend / intDivisor;
                    //console.log(result, 'result------')
                    return result;
                }
            },
            //bu0
            buzero(result) {
                let result1 = result + '';
                if (result1.indexOf('.') == '-1') {
                    result1 = result1 + '.00'
                }
                return result1
            },
            keepTwoDecimal(num) {
                const parsed = parseFloat(num);
                if (isNaN(parsed)) return 0;
                return Number(parsed.toFixed(2));
            },
            saveForm() {
                //console.log(this.formData.files, 'files')
                //console.log(this.isred, 'this.isred')
                //console.log(this.orderWs, 'this.orderWs')
                //console.log(this.i_isfrom, 'this.i_isfrom')
                if (this.i_fptype == null) {
                    this.$message.error(this.$t('invoiceEntry_please_enter_invoice_type')+'!');
                    return;
                }
                if (this.formData.vc_fpcode == '' && this.i_isfrom == 1) {
                    this.$message.error(this.$t('invoiceEntry_please_enter_invoice_number')+'!');
                    return;
                }
                if (this.i_kpkhid == 0) {
                    this.$message.error(this.$t('invoiceEntry_please_select_the_invoicing_party')+'!');
                    return;
                }
                /*if (this.formData.dt_fptime == '' || !this.formData.dt_fptime) {
                    this.$message.error(this.$t('invoiceEntry_please_select_the_invoicing_time')+'!');
                    return;
                }*/
                if (this.formData.dt_cwtime == '' || !this.formData.dt_cwtime) {
                    this.$message.error(this.$t('invoiceEntry_please_select_the_accounting_time')+'!');
                    return;
                }else{
                    const startDate = new Date(this.formData.dt_cwtime);
                    const endDate = new Date(this.lastCheckOutDate);
                    if (startDate <= endDate) {
                        this.$message.error(this.$t('invoiceEntry_the_accounting_date_must_be_greater_than_or_equal_to')+this.lastCheckOutDate);
                        return
                    }
                }

                if (this.companyId == 0) {
                    this.$message.error(this.$t('invoiceEntry_please_select_the_buyer')+'!');
                    return;
                }
                if (this.i_isagent == 1 && this.xsComId == 0) {
                    this.$message.error(this.$t('invoiceEntry_please_select_the_seller')+'!');
                    return;
                }
                /*if(this.orderWs==''||!this.orderWs){
                    this.$message.error(this.$t('invoiceEntry_please_select_an_order_first')+'!');
                }*/
                if (this.tableData.length == 0) {
                    this.$message.error(this.$t('invoiceEntry_please_select_invoice_type')+'!');
                    return;
                } else {
                    let kong = this.tableData.some(item => {
                        return item.f_pay_ws == 0//item.f_num==0||||item.f_pay_zzs==0
                    })
                    let pmkong = this.tableData.some(item => {
                        return item.vc_pzname == '' && item.i_type == 1
                    })
                    let numkong = this.tableData.some(item => {
                        return item.f_num == 0
                    })
                    let zk = this.tableData.some(item => {
                        return item.f_fpnum == 0 && this.i_isfrom == 1
                    })
                    //console.log('zk', zk)
                    //console.log('kong', kong)
                    //console.log('pmkong', pmkong)
                    /*if (pmkong) {
                        this.$message.error(this.$t('invoiceEntry_please_select_the_variety')+'!');
                        return;
                    }*///0509
                    /*if (this.i_fytype != 1) {
                        if (numkong && !zk) {
                            this.$message.error(this.$t('invoiceEntry_the_number_of_varieties_is_0'));///品种数量/税额
                            return;
                        }
                    }*/
                    /*if (kong && !zk) {
                        this.$message.error(this.$t('invoiceEntry_there_is_a_tax-free_amount_of_0'));///品种数量/税额
                        return;
                    }*/
                    //console.log('tableData', this.tableData)
                }
               /* if (this.i_fytype != 1) {
                    if (this.i_isfrom == 1) {
                        //判断单个品种发票数量和总发票数量
                        let data = this.deepClone(this.tableData)
                        this.splitparts = [];
                        this.syparts = [];
                        //存下i_type==0的数组
                        this.splitparts = data.filter(item => item.i_type == 0)
                        //console.log(this.splitparts, 'this.splitparts')
                        //存下i_type==1的数组
                        this.syparts = data.filter(item => item.i_type == 1)
                        //console.log(this.syparts, 'this.syparts')
                        let fparr = [];
                        data.map(mapitem => {
                            if (fparr.length == 0) {
                                fparr.push({vc_fkey_sub: mapitem.vc_fkey_sub, list: [mapitem]})
                            } else {
                                let res = fparr.some(item => {
                                    if (item.vc_fkey_sub == mapitem.vc_fkey_sub) {
                                        item.list.push(mapitem)
                                        return true
                                    }
                                })
                                if (!res) {
                                    fparr.push({vc_fkey_sub: mapitem.vc_fkey_sub, list: [mapitem]}
                                    )
                                }
                            }
                        });
                        //console.log("fparr", fparr);
                        fparr.map(mapitem => {
                            //mapitem.kyfpnum=mapitem.list[0].kyfpnum;
                            mapitem.kyfpnum = mapitem.list[0].f_fpnum;
                            let infnum = 0;
                            mapitem.list.map(listitem => {
                                //infnum += listitem.f_num
                                infnum += listitem.f_bcfpnum
                            })
                            mapitem.infnum = infnum
                        })
                        let everyX = fparr.every(item => {
                            item.kyfpnum = parseFloat(item.kyfpnum.toFixed(5))
                            item.infnum = parseFloat(item.infnum.toFixed(5))
                            return item.kyfpnum == item.infnum
                        })
                        //console.log(everyX, 'everyX')
                        if (!everyX) {
                            this.$message.error(this.$t('invoiceEntry_the_number_of_invoices_is_not_equal_to_the_original_invoice_quantity'));
                            return
                        }
                        //console.log('pzdetails', this.pzdetails)
                        this.dataMx = {
                            data: this.splitparts.length > 0 ? this.syparts : data,
                            pzdetails: this.pzdetails,
                            i_isfrom: this.i_isfrom,
                            i_fytype: this.i_fytype,
                            i_flag: this.i_flag,
                        }
                        this.dialogVisible_mx = true;
                        return
                    } else {
                        let data = this.deepClone(this.tableData)
                        //console.log(data, 'data-----')
                        //console.log(this.pzdetails, 'this.pzdetails-----')
                        this.dataMx = {
                            data: data,
                            pzdetails: this.pzdetails,
                            i_isfrom: this.i_isfrom,
                            i_fytype: this.i_fytype,
                        }
                        this.dialogVisible_mx = true;
                        return
                    }
                }*/
                this.save();
            },
            //保存
            async save() {
                let hejiData = [...this.tableData];
                const hasCf = hejiData.some(item => item.i_type == 1);
                if(hasCf){
                    hejiData=hejiData.filter(itemB => itemB.i_type == 1);
                }
                //console.log(hejiData,'hejiData')
                //价税合计
                let tp = 0;
                let ts = 0;
                let gs = 0;
                let totalfnum = 0;
                hejiData.map(item=>{
                    tp += item.f_pay_ws;
                    ts += item.f_pay_zzs;
                    if(this.i_flag==1){
                        gs += item.f_pay_gs
                    }
                    //totalfnum += item.f_num;
                });
                this.f_pay_ws= parseFloat(this.keepTwoDecimal(tp));
                this.f_pay_zzs= parseFloat(this.keepTwoDecimal(ts));
                this.f_pay_gs= parseFloat(this.keepTwoDecimal(gs));
                //totalfnum=parseFloat(totalfnum);
                //totalfnum=parseFloat(totalfnum.toFixed(5));
                let num = this.keepTwoDecimal(tp+ts);
                this.totalPrice = this.returnFloat(num);
                this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);
                //console.log('totalPrice',this.totalPrice);
                //console.log('fptotalPrice',this.fptotalPrice);
                //console.log('totalfnum----',totalfnum);
                //console.log('pzdetails-----',this.pzdetails);
                /*if(this.i_isfrom==1&&this.i_fytype!=1){
                    if(this.fp_num!=totalfnum){
                        let title = '发票数量与原发票数量'+parseFloat(this.fp_num)+'不一致！';
                        this.$message.error(title);
                        return;
                    }
                }*/
                /*if(this.i_fytype==1){
                    if(parseFloat(this.sqtotalPrice)!=this.fptotalPrice){
                        let title = '付款申请总金额与原发票金额'+this.fptotalPrice+'不一致！';
                        this.$message.error(title);
                        return;
                    }
                }*/

                if(this.isred){
                    let spillPay = Math.abs(this.spillfppay);
                    let totalPay = Math.abs(this.totalPrice);
                    //console.log(spillPay,'spillPay',totalPay,'totalPay')
                    if(parseFloat(totalPay)!=spillPay){
                        let title = this.$t('invoiceEntry_tax_inclusive_amount_and_invoice_amount_associated_with_red_offset')+ this.spillfppay +this.$t('invoiceEntry_inconsistent');
                        this.$message.error(title);
                        return;
                    }
                    if(parseFloat(totalPay)>spillPay){
                        let title = this.$t('invoiceEntry_the_absolute_value_of_the_total_price_and_tax_for_this_transaction_cannot_exceed_the_invoice_amount_of_the_associated_invoice')+ this.spillfppay +this.$t('invoiceEntry_absolute_value');
                        this.$message.error(title);
                        return;
                    }

                }else{
                    if(parseFloat(this.totalPrice)!=this.fptotalPrice){
                        let title = this.$t('invoiceEntry_the_inclusive_tax_amount_is_inconsistent_with_the_original_invoice_amount',[this.fptotalPrice]);
                        this.$message.error(title);
                        return;
                    }
                }


                //console.log('save------', this.tableData);
                const ids = [
                    ...new Set(
                        this.tableData.flatMap(obj => obj.details.map(item => item.i_id))
                    )
                ];
                this.orderWs = ids.toString();
                this.disinput_fpcode = true;
                this.disinput2 = true;//daikai/xiaoshou
                this.disinput = true;//禁下拉输入
                this.disabled = true;//禁保存
                this.isbtn = true;//禁减号
                this.isedit = true;//禁单选
                this.loading = true;
                let param = {
                    "i_id": this.i_id,
                    "i_type": this.i_type, //发票类型，2：采购发票， 3： 运费发票 ，32：港杂发票， 4：开证发票 ， 5： 仓储发票 ， 6：保险发票
                    'i_khtype': this.i_khtype == 4 ? 2 : this.i_khtype,
                    'i_fptype': this.i_fptype,
                    'vc_fptype': this.vc_fptype,
                    "vc_fpcode": this.formData.vc_fpcode,//发票编号,
                    "i_kpkhid": this.i_isagent == 1 ? this.xsComId : this.i_kpkhid, //销售方，代开时为销售方，非代开时为开票方
                    "vc_kpkhname": this.i_isagent == 1 ? this.xsComname : this.vc_kpkhname,//开票方
                    "vc_khcreditcode": this.vc_khcreditcode, //开票方识别号
                    "vc_gscreditcode": this.vc_gscreditcode, //开票方识别号
                    "dt_fptime": this.formData.dt_fptime, //开票日期
                    "i_gsid": this.companyId,
                    "vc_gsname": this.companyName,
                    "i_isagent": this.i_isagent, //是否代开，1是0否
                    'i_dkable': this.isdk,
                    "i_dlkhid": this.i_isagent == 1 ? this.i_kpkhid : 0,
                    "vc_dlkhname": this.i_isagent == 1 ? this.vc_kpkhname : '', //代理开票方,
                    "f_pay": parseFloat(this.totalPrice), //开票金额
                    "f_pay_ws": this.f_pay_ws,
                    "f_pay_zzs": this.f_pay_zzs,
                    'f_gs': this.f_pay_gs,
                    'f_sl': this.details_form.f_sl,
                    "vc_note": this.formData.vc_note,
                    "i_isfrom": this.i_isfrom, //来源，0来源于税务云，1来源于员工上传
                    //"vc_mainfile_newname":this.i_isfrom==0&&this.type=='add'?this.formData.files[0].vc_path:this.vc_newname,//发票上传附件的newname
                    "vc_mainfile_newname": this.vc_newname,
                    'details': this.tableData,
                    "delIds": this.delIds,
                    //'vc_fkey':this.i_isfrom==1?this.vc_fkey:"",
                    'vc_fkey': this.vc_fkey,
                    'vc_no': this.orderWs,
                    'i_gid': sessionStorage.getItem("i_gid"),
                    'i_bzid_yb': this.i_bzid_yb,
                    //'invoiceType':this.isred?2:1,
                    'i_invoiceType': this.i_invoiceType,
                    'vc_relateinvoice_code': this.i_invoiceType == '2' ? this.copyfpcode : null,
                    'i_glfpid': this.i_invoiceType == '2' ? this.i_glfpid : null,
                    'i_fytype': this.i_fytype,
                    'i_fyid':this.vc_fymx,
                    'i_fymx':this.vc_fymx,
                    'dt_cwtime':this.formData.dt_cwtime,
                };
                //console.log(param, 'param')
                //return;
                let res = await API.save(param);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.loading = false;
                    this.isshua = 1;
                    this.type = 'edit';
                    this.disabled = false;
                    this.isbtn = false;//禁减号
                    this.i_id = res.data;
                    this.i_gsid = res.i_gsid;
                    this.i_kpkhid =res.i_kpkhid;
                    this.multipleSelection = [];
                    this.needsave=false;
                    //this.isover=res.data.isover;
                    this.detail()
                    //this.cancel('1');
                } else if (res.code == -2) {
                    this.disinput_fpcode = false;
                    this.disinput2 = false;//daikai/xiaoshou
                    this.disinput = false;//禁下拉输入
                    this.disabled = false;//禁保存
                    this.isbtn = false;//禁减号
                    this.isedit = false;//禁单选
                    this.loading = false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.disinput_fpcode = false;
                    this.disinput2 = false;//daikai/xiaoshou
                    this.disinput = false;//禁下拉输入
                    this.disabled = false;//禁保存
                    this.isbtn = false;//禁减号
                    this.isedit = false;//禁单选
                    this.loading = false;
                    this.$message.error(res.message);
                }
            },
            cancel(val) {
                this.delIds = [];
                this.$emit('cancelDialog', val);
            },
            openpm(data, index, row) {
                //console.log(row,index,'-')
                if(row.i_type==0){
                    return;
                }
                if(this.orderWs==''){
                    this.$message.error(this.$t('invoiceEntry_please_select_an_order_first')+'!');
                }else{
                    this.tableData[index].visible=true;
                    this.$set(data,index,row);
                    //console.log('row.vc_pzname',row.vc_pzname);
                    if(this.i_id!=0&&row.i_id!=0)this.pickorderlist=row.details;
                    this.productDetails={
                        i_id:this.i_id,
                        i_type:this.i_type,
                        i_khtype:this.i_isagent==1?2:this.i_khtype,
                        i_kpkhid: this.i_isagent==1?this.xsComId:this.i_kpkhid ,
                        i_gsid:this.companyId,
                        vc_search: '',
                        index:index,
                        row:row,
                        selected:this.selectD,
                        orderWs:this.orderWs,
                        i_isfrom:this.i_isfrom,
                    }
                    if(this.i_fytype==1){
                        this.currentInvoiceId = row.localId;
                        this.productDetails.varieties=this.selectD
                        this.productDetails.invoices=this.tableData
                        this.productDetails.f_pay=this.fptotalPrice
                    }
                }
            },
            popShow() {
                let map = {
                    vc_pzname: "",
                    visible: false,
                    f_rate: 1,
                    f_sl: this.f_sl,
                    i_type: 1,
                };
                //this.tableData.unshift(map);
                this.tableData.push(map);
                //console.log('this.tableData', this.tableData);
            },
            closePop(index, len) {
                //console.log('index', index)
                if (index < this.tableData.length) {
                    if (len == 1) {
                        this.tableData[index].visible = false;
                    } else {
                        this.tableData.map(item => {
                            item.visible = false
                        })
                    }
                } else {
                    this.tableData.map(item => {
                        item.visible = false
                    })
                }
                if (!index) {
                    this.tableData.map(item => {
                        item.visible = false
                    })
                }
                this.productDetails = {};
                //this.isbtn=false;
            },
            //根据i_pzid拆分数组
            splitArrayByKey(arr, key) {
                return arr.reduce((acc, obj) => {
                    const value = obj[key];
                    if (!acc.hasOwnProperty(value)) {
                        acc[value] = [];
                    }
                    acc[value].push(obj);
                    return acc;
                }, {});
            },
            replaceDuplicateValuesWithEmptyString(arr, key) {
                let seenValues = new Set();
                return arr.map(obj => {
                    let value = obj[key];
                    if (seenValues.has(value)) {
                        obj[key] = ''; // 将重复的值替换为空字符串
                    } else {
                        seenValues.add(value); // 将第一次出现的值添加到集合中
                    }
                    return obj;
                });
            },

            cancelDialog_alert(data) {
                this.dialogVisible_alert = false;
            },
            onSplitConfirm(updatedList,idx) {
                this.tableData = updatedList;
                this.tableData[idx].details=[];
                this.tableData[idx].vc_pzname='';
                //console.log(updatedList, 'updatedList')
            },
            //拆分开票
            splitdata(row, index) {
                this.alertdata = {
                    data: this.tableData,
                    row: row,
                    index:index
                }
                this.currentMainRow = row;
                this.dialogVisible_alert = true;
                /* this.alertdata={
                    index:index,
                    pickone:row,
                    data:tabs,
                    i_isfrom:this.i_isfrom,
                    i_fytype:this.i_fytype,
                    i_flag:this.i_flag,
                    flagpzList:this.flagpzList,
                    details_form:this.details_form,
                }*/
            },

            onVarietyConfirm({invoiceId, selections, ids, dels,type,choopay,invoices}) {
                this.dialogVisible_order = false;
                if (type == 'back') {
                } else {
                    if(this.i_fytype!=1)this.tableData = invoices;
                    const invoice = this.tableData.find(i => i.localId === invoiceId);
                    //console.log(invoice,'invoice')
                    if (invoice) {
                        // 使用 this.$set 动态覆盖更新原发票底下的 details。无论是追加还是减少，这里都是最终全量结果
                        this.$set(invoice, 'details', [...selections]);
                        const purchaseCwInvoiceIds=[...new Set([...this.deletedDataIds, ...dels])];
                        this.$set(invoice, 'purchaseCwInvoiceIds', purchaseCwInvoiceIds);
                        //console.log(invoice.f_pay,choopay,'11111')
                        if(invoice.f_pay!==choopay){
                            this.$set(invoice, 'i_isdiffer', 1);
                        }else{
                            this.$set(invoice, 'i_isdiffer', 0);
                        }
                        // 核心亮点：数据更新后，computed 自动触发，页面重新拍平。
                        // 原来 3 条，如果现在勾了 4 条就自动变 4 行；勾了 2 条就自动变 2 行。
                    }
                    /*//console.log(invoiceId, 'selections');
                    //console.log(this.tableData, 'this.tableData');
                    const invoice = this.tableData.find(i => i.index === invoiceId);
                    //console.log(invoice, 'invoice');
                    invoice.details =  [...selections];
                    invoice.vc_pzname = this.i_fytype != 1 ? selections[0].vc_pzname : this.vc_type;
                    invoice.purchaseCwInvoiceIds=dels;
                    //console.log(invoice.details, 'invoice.details');
                    //console.log(this.tableData, 'this.tableData==2');*/
                    this.selectD = [...selections];
                    this.orderids = ids;
                    //console.log(this.orderWs, 'orderWs');
                    //console.log(this.orderids, 'orderids');
                    this.needsave=true;
                }
            },

            //产品列表
            transValue(map, index, row) {
                let value = map.data;
                //console.log("选中的品种", value);
                //console.log("选中的行", index);
                //console.log("行数据", row);
                //console.log("订单list", this.flagpzList);
                //console.log("i_isfrom", this.i_isfrom);
                //console.log("this.details_form", this.details_form);
                if (value.length != 0) {
                    if (value.length == 1 && row.i_pzid != value[0].i_pzid) {

                    } else {
                        if (this.i_isfrom == 1) {
                            if (row.i_id != 0 && row.i_id) {
                                this.delIds.push(row.i_id)
                            }
                            //console.log(this.delIds, 'this.delIds')
                        }
                    }
                    if (this.i_isfrom == 1) {
                        value.map(item => {
                            item.kyfpnum = map.fpnum ? map.fpnum : 0;
                            if (this.i_flag == 1) {
                                //console.log(this.i_flag, 'this.i_flag1')
                                this.flagpzList.map(orditem => {
                                    if (item.i_pzid == orditem.i_pzid) {
                                        item.f_price_yb = orditem.f_price_yb;
                                        item.vc_bzsymbol = orditem.vc_bzsymbol;
                                    }
                                })
                                item.f_num = map.fpnum;
                                item.f_sl_gs = this.details_form.f_sl_gs;
                            } else {
                                //item.f_num=item.f_syglfpnum<item.kyfpnum?item.f_syglfpnum:item.kyfpnum;
                                item.f_num = item.kyfpnum;
                            }
                            item.visible = false;
                            item.i_id = 0;
                            item.f_rate = 1;
                            item.f_sl = row.f_sl;
                            item.vc_fkey_sub = row.vc_fkey_sub;
                            item.vc_fppzname = row.vc_fppzname;
                            item.vc_fpbzstyle = row.vc_fpbzstyle;
                            item.vc_fpunit = row.vc_fpunit;
                            item.vc_pzname = item.vc_pzname;
                            item.i_pzid = item.i_pzid;
                            item.f_bcfpnum = row.f_fpnum;
                            item.f_fpnum = row.f_fpnum;
                            item.f_fpprice = row.f_fpprice;
                            item.f_fppay_ws = row.f_fppay_ws;
                            item.f_fppay_zzs = row.f_fppay_zzs;
                            item.f_pay_gs = row.f_pay_gs;
                            //console.log(item.f_num, 'item.f_num=-=-=-=-=-=-=-=-=-=-=-=')
                            item.i_type = 1;
                            if (item.f_num == 0) {
                                if (item.kyfpnum == 0) {
                                    let bl = 0;
                                    //console.log(bl, 'bl')
                                    item.f_price_ws = bl * item.f_fpprice
                                    item.f_pay_ws = item.f_fppay_ws;
                                    item.f_pay_zzs = item.f_fppay_zzs;
                                    item.f_pay = item.f_pay_ws + item.f_pay_zzs;
                                    //关税税率写死1%(已返
                                    let gs = item.f_pay_ws * (item.f_sl_gs ? item.f_sl_gs : 0)
                                    gs = parseFloat(this.keepTwoDecimal(gs));
                                    item.f_pay_gs = gs;
                                } else {
                                    let bl = this.preciseDiv(item.f_fpnum, item.kyfpnum);
                                    bl = parseFloat(bl);
                                    //console.log(bl, 'bl')
                                    item.f_price_ws = bl * item.f_fpprice
                                    item.f_pay_ws = item.f_fppay_ws;
                                    item.f_pay_zzs = item.f_fppay_zzs;
                                    item.f_pay = item.f_pay_ws + item.f_pay_zzs;
                                    //关税税率写死1%(已返
                                    let gs = item.f_pay_ws * item.f_sl_gs
                                    gs = parseFloat(this.keepTwoDecimal(gs));
                                    item.f_pay_gs = gs;
                                }

                            } else {
                                let bl = this.preciseDiv(item.f_fpnum, item.kyfpnum);
                                bl = parseFloat(bl);
                                item.f_price_ws = bl * item.f_fpprice;
                                if (this.i_flag == 1) {
                                    //关税税率写死1%(已返
                                    let gs = item.f_num * item.f_price_ws * item.f_sl_gs
                                    gs = parseFloat(this.keepTwoDecimal(gs));
                                    item.f_pay_gs = gs;
                                    let payws = (item.f_num * item.f_price_ws) + item.f_pay_gs
                                    payws = parseFloat(this.keepTwoDecimal(payws));
                                    item.f_pay_ws = payws;
                                    let fzzs = item.f_pay_ws * item.f_sl;
                                    fzzs = parseFloat(this.keepTwoDecimal(fzzs));
                                    item.f_pay_zzs = fzzs;
                                } else {
                                    item.f_price_ws = bl * item.f_fpprice
                                    let payws = item.f_num * item.f_price_ws
                                    payws = parseFloat(this.keepTwoDecimal(payws));
                                    item.f_pay_ws = payws;
                                    let fzzs = item.f_pay_ws * item.f_sl;
                                    fzzs = parseFloat(this.keepTwoDecimal(fzzs));
                                    item.f_pay_zzs = fzzs;
                                }
                            }
                        });
                    } else {
                        value.map(item => {
                            item.details = [];
                            item.kyfpnum = map.fpnum;
                            item.visible = false;
                            item.i_id = 0;
                            item.f_rate = 1;
                            //item.f_sl=this.f_sl;
                            item.f_sl = this.details_form.f_sl ? this.details_form.f_sl : this.f_sl;
                            item.f_sl_gs = this.details_form.f_sl_gs ? this.details_form.f_sl_gs : 0;
                            item.vc_fppzname = '';
                            item.vc_pzname = item.vc_pzname;
                            item.i_pzid = item.i_pzid;
                            item.f_num = item.f_syglfpnum;
                            item.f_price_ws = 0;
                            item.f_pay_ws = 0;
                            item.f_pay_zzs = 0;
                            item.i_type = 1;
                            if (this.i_flag == 1) {
                                //console.log(this.i_flag, 'this.i_flag1')
                                //console.log(this.flagpzList, 'this.flagpzList')
                                this.flagpzList.map(orditem => {
                                    if (item.i_pzid == orditem.i_pzid) {
                                        item.f_price_yb = orditem.f_price_yb;
                                        item.vc_bzsymbol = orditem.vc_bzsymbol;
                                    }
                                })
                            }
                        });
                    }
                    //console.log("map选中的品种", value);
                    let name = this.tableData[index].vc_pzname;
                    if (name == '') {
                        this.tableData.splice(index, 1, ...value);
                    } else {
                        if (this.i_isfrom == 1) {
                            this.tableData.splice(index, 0, ...value);
                        } else {
                            this.tableData = [...this.tableData, ...value];
                        }
                    }
                    let arr = this.deepClone(this.tableData);
                    //console.log('arr', arr);
                    if (this.i_isfrom == 1) {
                        let hash = {};
                        arr = arr.reduce(function (item, next) {
                            hash[next.i_pzid + '/' + next.vc_fppzname + '/' + next.vc_fkey_sub] ? '' : hash[next.i_pzid + '/' + next.vc_fppzname + '/' + next.vc_fkey_sub] = true && item.push(next);
                            return item
                        }, []);
                        //console.log("arr--", arr);
                        this.formData.tableData = arr;
                        this.tableData = arr;
                        this.selectD = [];
                    } else {
                        let hash = {};
                        arr = arr.reduce(function (item, next) {
                            hash[next.i_pzid] ? '' : hash[next.i_pzid] = true && item.push(next);
                            return item
                        }, []);
                        //console.log("arr--", arr);
                        this.formData.tableData = arr;
                        this.tableData = arr;
                        this.selectD = value;
                    }
                    //console.log('this.tableDataaaaaaaaaaaaaaaaaaaaaa', this.tableData)
                    //价税合计
                    let tp = 0;
                    let ts = 0;
                    this.tableData.map(item => {
                        tp += item.f_pay_ws;
                        ts += item.f_pay_zzs;
                    });
                    this.f_pay_ws = parseFloat(this.keepTwoDecimal(tp));
                    this.f_pay_zzs = parseFloat(this.keepTwoDecimal(ts));
                    let num = this.keepTwoDecimal(tp + ts);
                    this.totalPrice = this.returnFloat(num);
                    this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);
                } else {
                    //console.log('单位换算失败', map);
                    let pz = map.pzids;
                    //console.log(pz, 'pz')
                    pz.map(item => {
                        item.unit = 'no'
                        item.i_type = 1;
                        item.kyfpnum = row.f_fpnum;
                        item.i_id = 0;
                        item.visible = false;
                        item.f_rate = 1;
                        item.f_sl = row.f_sl;
                        item.vc_fkey_sub = row.vc_fkey_sub;
                        item.vc_fppzname = row.vc_fppzname;
                        item.vc_fpbzstyle = row.vc_fpbzstyle;
                        item.vc_fpunit = row.vc_fpunit;
                        item.vc_pzname = item.vc_pzname;
                        item.i_pzid = item.i_pzid;
                        item.f_num = row.f_fpnum;
                        item.f_bcfpnum = row.f_fpnum;
                        item.f_fpnum = row.f_fpnum;
                        item.f_fpprice = row.f_fpprice;
                        item.f_fppay_ws = row.f_fppay_ws;
                        item.f_fppay_zzs = row.f_fppay_zzs;
                        item.f_pay_gs = row.f_pay_gs;
                        if (this.i_flag == 1) {
                            //console.log(this.i_flag, 'this.i_flag1')
                            //console.log(this.flagpzList, 'this.flagpzList')
                            this.flagpzList.map(orditem => {
                                if (item.i_pzid == orditem.i_pzid) {
                                    item.f_price_yb = orditem.f_price_yb;
                                    item.vc_bzsymbol = orditem.vc_bzsymbol;
                                }
                            })
                        }
                        let bl = 1;
                        //console.log(bl, 'bl')
                        item.f_price_ws = bl * row.f_fpprice
                        item.f_pay_ws = row.f_fppay_ws;
                        item.f_pay_zzs = row.f_fppay_zzs;
                        item.f_pay = row.f_pay_ws + row.f_pay_zzs;
                        //关税税率写死1%(已返
                        let gs = row.f_pay_ws * (row.f_sl_gs ? row.f_sl_gs : 0)
                        gs = parseFloat(this.keepTwoDecimal(gs));
                        item.f_pay_gs = gs;
                    })
                    //console.log("单位换算失败 用pzids", pz);
                    let name = this.tableData[index].vc_pzname;
                    if (name == '') {
                        this.tableData.splice(index, 1, ...pz);
                    } else {
                        if (this.i_isfrom == 1) {
                            this.tableData.splice(index, 0, ...pz);
                        } else {
                            this.tableData = [...this.tableData, ...pz];
                        }
                    }
                    let arr = this.deepClone(this.tableData);
                    //console.log('arr', arr);
                    if (this.i_isfrom == 1) {
                        let hash = {};
                        arr = arr.reduce(function (item, next) {
                            hash[next.i_pzid + '/' + next.vc_fppzname + '/' + next.vc_fkey_sub] ? '' : hash[next.i_pzid + '/' + next.vc_fppzname + '/' + next.vc_fkey_sub] = true && item.push(next);
                            return item
                        }, []);
                        //console.log("arr--", arr);
                        this.formData.tableData = arr;
                        this.tableData = arr;
                        this.selectD = [];
                    } else {
                        let hash = {};
                        arr = arr.reduce(function (item, next) {
                            hash[next.i_pzid] ? '' : hash[next.i_pzid] = true && item.push(next);
                            return item
                        }, []);
                        //console.log("arr--", arr);
                        this.formData.tableData = arr;
                        this.tableData = arr;
                        this.selectD = value;
                    }
                    //console.log('this.tableData-单位换算失败', this.tableData)
                    //价税合计
                    let tp = 0;
                    let ts = 0;
                    this.tableData.map(item => {
                        tp += item.f_pay_ws;
                        ts += item.f_pay_zzs;
                    });
                    this.f_pay_ws = parseFloat(this.keepTwoDecimal(tp));
                    this.f_pay_zzs = parseFloat(this.keepTwoDecimal(ts));
                    let num = this.keepTwoDecimal(tp + ts);
                    this.totalPrice = this.returnFloat(num);
                    this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);
                }
                //处理发票数量
                /*if(this.i_isfrom==1){
                    let vc_fkey_sub = this.tableData[0].vc_fkey_sub;
                    let other = this.tableData.filter(item=>{
                        return item.vc_fkey_sub != vc_fkey_sub
                    })
                    console.log('other',other)
                    if(other.length>0){
                        let hash = {};
                        other = other.reduce(function(item, next) {
                            hash[next.vc_fkey_sub] ? '' : hash[next.vc_fkey_sub] = true && item.push(next);
                            return item
                        }, []);
                        console.log("other--",other);
                        this.fp_num = 0;
                        other.map(otheritem=>{
                            this.fp_num += otheritem.kyfpnum
                        })
                        this.fp_num = this.fp_num+this.tableData[0].kyfpnum;
                        this.fp_num = parseFloat(this.fp_num);
                        this.fp_num = parseFloat(this.fp_num).toFixed(5);

                    }else{
                        this.fp_num = 0;
                        this.fp_num = this.tableData[0].kyfpnum;
                        this.fp_num = parseFloat(this.fp_num);
                        this.fp_num = parseFloat(this.fp_num).toFixed(5);
                    }
                    console.log('发票总数量this.fp_num',this.fp_num);
                }*/
                if (this.i_fytype != 1) {
                    //this.handleRelevancenum('pl');
                }
            },

            deepClone(source) {
                if (typeof source !== 'object' || source == null) {
                    return source;
                }
                const target = Array.isArray(source) ? [] : {};
                for (const key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        if (typeof source[key] === 'object' && source[key] !== null) {
                            target[key] = this.deepClone(source[key]);
                        } else {
                            target[key] = source[key];
                        }
                    }
                }
                return target;
            },
            deleteRow(value, index) {
                //console.log('this.isbtn', this.isbtn)
                //if(!this.isbtn){
                this.tableData.splice(index, 1);
                if (value.i_id) {
                    this.delIds.push(value.i_id);
                    //console.log('this.delIds', this.delIds)
                }
                ;
                //console.log(this.tableData, 'this.tableData---')
                //价税合计
                let tp = 0;
                let ts = 0;
                this.tableData.map(item => {
                    tp += item.f_pay_ws;
                    ts += item.f_pay_zzs;
                });
                this.f_pay_ws = parseFloat(this.keepTwoDecimal(tp));
                this.f_pay_zzs = parseFloat(this.keepTwoDecimal(ts));
                //this.totalPrice = parseFloat(this.keepTwoDecimal(tp)) + parseFloat(this.keepTwoDecimal(ts));
                //this.totalPrice = parseFloat(this.keepTwoDecimal(tp+ts));
                let num = this.keepTwoDecimal(tp + ts);
                this.totalPrice = this.returnFloat(num);
                this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);
                //}
            },
            //获取当天日期
            getDateYYYYMMddHHMMSS() {
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.formData.dt_createtime = `${date.getFullYear()}-${month}-${strDate}`;
            },
            choosedk(e) {
                this.i_isagent = e;
                if (this.i_kpkhid != 0 && this.companyId != 0 && this.i_isagent == 1) {
                    this.getKhByKz();
                }
            },
            //销售方
            async getKhByKz() {
                let param = {
                    i_gsid: this.companyId,
                    i_dlkhid: this.i_kpkhid,
                    i_mid: this.mid,
                };
                let res = await API.getKhByKz(param);
                if (res.code == 1) {
                    this.xsData = res.data.list;

                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //根据开票方获取发票编号列表
            async beforehandle() {
                let param = {
                    'i_mid': this.mid,
                    'vc_kpkhname': this.vc_kpkhname,
                    'vc_khcreditcode': this.vc_khcreditcode,
                    'vc_gsname': this.companyName,
                    'vc_gscreditcode': this.vc_gscreditcode,

                };
                let res = await API.beforehandle(param);
                if (res.code == 1) {
                    this.codeData = res.data.list;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //发票类型
            async fplx() {
                let param = {
                    i_mid: this.mid,
                };
                let res = await API.fplx(param);
                if (res.code == 1) {
                    this.fplxData = res.data.list;
                    this.i_fptype = res.data.list[0].i_id;
                    this.vc_fptype = res.data.list[0].vc_name;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //获取交易公司
            async getCompanyList() {
                let param = {
                    i_mid: this.mid,
                };
                let res = await API.getCompanyList(param);
                if (res.code == 1) {
                    this.compsData = res.data;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //查询开票类型
            async fptype() {
                let param = {
                    i_mid: this.mid,
                    isCw:0,
                    typeList :[0,1,2],
                };
                let res = await API.fptype(param);
                if (res.code == 1) {
                    this.fpType = res.data.list;
                    this.i_type = res.data.list[0].i_id;
                    this.vc_type = res.data.list[0].vc_name;
                    this.i_khtype = res.data.list[0].i_khtype;
                    this.i_origin_khtype = res.data.list[0].i_origin_khtype;
                    this.vc_fymx = res.data.list[0].vc_fymx;
                    //this.i_isagent = res.data.list[0].i_isagent;
                    this.isdk = res.data.list[0].i_dkable;
                    this.i_issd = res.data.list[0].i_issd;
                    this.i_flag = res.data.list[0].i_flag;
                    this.f_sl = res.data.list[0].f_sl;
                    this.i_fytype = res.data.list[0].i_fytype;
                    this.getkhlist('');
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //获取开票方
            async getkhlist(val) {
                let param = {
                    currentPage: 1,
                    pageSize: 50,
                    vc_search: val,
                    //i_khtype: this.i_khtype,
                    i_khtype:this.i_khtype==0?'3,4,5,6,7,8,9':this.i_khtype,
                };
                let res = await API.getkhlist(param);
                if (res.code == 1) {
                    this.kpfData = res.data.list;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            yanzheng() {
                if (this.i_kpkhid == 0) {
                    this.$message.error(this.$t('invoiceEntry_please_select_the_invoicing_party_first')+'!');
                    return;
                }
                if (this.companyId == 0) {
                    this.$message.error(this.$t('invoiceEntry_please_select_the_buyer_first')+'!');
                    return;
                }

            },
            remoteMethodkp(val) {
                this.getkhlist(val);
            },
            changeData(e, type) {
                if (this.i_isfrom == 0) {
                    this.tableData = [];
                    this.orderWs = '';
                    this.orderids = [];
                }
                //console.log(e,type);
                if (type == 'bz') {
                    this.i_bzid = e;
                    let choo = this.bzData.filter(item => {
                        return item.i_id == e
                    });
                    if (choo.length > 0) {
                        this.vc_bzname = choo[0].vc_name;
                        this.f_rate = choo[0].f_rate;
                    } else {
                        this.vc_bzname = '';
                        this.f_rate = 0;
                    }
                }
                if (type == 'fpt') {
                    this.i_type = e;
                    let choo = this.fpType.filter(item => {
                        return item.i_id == e
                    });
                    if (choo.length > 0) {
                        this.vc_type = choo[0].vc_name;
                        this.i_khtype = choo[0].i_khtype;
                        this.i_origin_khtype = choo[0].i_origin_khtype;
                        this.vc_fymx = choo[0].vc_fymx;
                        //this.i_isagent=choo[0].i_isagent;
                        this.isdk = choo[0].i_dkable;
                        this.i_issd = choo[0].i_issd;
                        this.i_flag = choo[0].i_flag;
                        this.f_sl = choo[0].f_sl;
                        this.i_fytype = choo[0].i_fytype;
                        this.kpfData = [];
                        this.i_kpkhid = 0;
                        this.vc_kpkhname = '';
                        this.i_isagent = 0;
                        this.getkhlist('');
                        if (this.i_issd == 1) {
                            let choo = this.fplxData.filter(item => {
                                return item.i_id == '1112'
                            });
                            this.i_fptype = choo[0].i_id;
                            this.vc_fptype = choo[0].vc_name;
                        } else {
                            let choo = this.fplxData.filter(item => {
                                return item.i_id == '0'
                            });
                            this.i_fptype = choo[0].i_id;
                            this.vc_fptype = choo[0].vc_name;
                        }
                        /*if(this.i_flag==1&&this.i_isfrom==0){
                            this.getbzlist();
                        }*/
                    } else {
                        this.vc_type = '';
                        this.i_khtype = 0;
                        this.i_origin_khtype = 0;
                        this.vc_fymx = '';
                        //this.i_isagent=0;
                        this.isdk = 0;
                        this.i_issd = 0;
                        this.i_flag = 0;
                        this.f_sl = 0;
                        this.i_fytype = 0;
                        this.kpfData = [];
                        this.i_kpkhid = 0;
                        this.vc_kpkhname = '';
                        this.i_isagent = 0;
                    }

                }
                if (type == 'state') {
                    this.isover = e;
                    let choo = this.stateData.filter(item => {
                        return item.isover == e
                    });
                    //console.log(choo, 'choo');
                    if (choo.length > 0) {
                        this.vc_isover = choo[0].vc_name;
                    } else {
                        this.vc_isover = '';
                    }
                }
                if (type == 'kpf') {
                    if (this.i_khtype == 0) {
                        this.$message.error(this.$t('invoiceEntry_please_select_the_invoice_type_first'));
                    } else {
                        this.i_kpkhid = e;
                        let choo = this.kpfData.filter(item => {
                            return item.i_id == e
                        });
                        //console.log(choo, 'choo');
                        if (choo.length > 0) {
                            this.vc_kpkhname = choo[0].vc_name;
                            this.vc_khcreditcode = choo[0].vc_creditcode;
                            this.xsData = [];
                            this.xsComname = '';
                            this.xsComId = 0;
                        } else {
                            this.vc_kpkhname = '';
                            this.vc_khcreditcode = '';
                            this.xsData = [];
                            this.xsComname = '';
                            this.xsComId = 0;
                        }
                    }
                    if (this.i_kpkhid != 0 && this.companyId != 0 && this.i_isagent == 1) {
                        this.getKhByKz();
                    }
                    if (this.i_kpkhid != 0 && this.companyId != 0 && this.i_isfrom == 1) {
                        //this.beforehandle();
                    }
                }
                if (type == 'gs') {
                    this.companyId = e;
                    let choo = this.compsData.filter(item => {
                        return item.i_id == e
                    });
                    //console.log(choo, 'choo');
                    if (choo.length > 0) {
                        this.companyName = choo[0].vc_name;
                        this.vc_gscreditcode = choo[0].vc_creditcode;
                        this.lastCheckOutDate =  choo[0].lastCheckOutDate;
                        this.xsData = [];
                        this.xsComname = '';
                        this.xsComId = 0;
                    } else {
                        this.companyName = '';
                        this.vc_gscreditcode = '';
                        this.lastCheckOutDate = '';
                        this.xsData = [];
                        this.xsComname = '';
                        this.xsComId = 0;
                    }
                    if (this.i_kpkhid != 0 && this.companyId != 0 && this.i_isagent == 1) {
                        this.getKhByKz();
                    }
                    if (this.i_kpkhid != 0 && this.companyId != 0 && this.i_isfrom == 1) {
                        //this.beforehandle();
                    }
                }
                if (type == 'xs') {
                    this.xsComId = e;
                    let choo = this.xsData.filter(item => {
                        return item.i_id == e
                    });
                    //console.log(choo, 'choo');
                    if (choo.length > 0) {
                        this.xsComname = choo[0].vc_name;
                        this.vc_khcreditcode = choo[0].vc_creditcode;
                    } else {
                        this.xsComname = '';
                        this.vc_khcreditcode = '';
                    }
                }
                if (type == 'fplx') {
                    this.i_fptype = e;
                    let choo = this.fplxData.filter(item => {
                        return item.i_id == e
                    });
                    //console.log(choo, 'choo');
                    if (choo.length > 0) {
                        this.vc_fptype = choo[0].vc_name;
                    } else {
                        this.vc_fptype = '';
                    }
                }
                if (type == 'code') {
                    this.vc_fkey = e;
                    if (this.vc_fkey != 0) {
                        this.beforedetail()
                    }

                }


            },
            clearsearch(type) {
                if (this.i_isfrom == 0) {
                    this.tableData = [];
                    this.orderWs = '';
                    this.orderids = [];
                }
                if (type == 'bz') {
                    this.i_bzid = 0;
                    this.vc_bzname = '';
                    this.f_rate = 0;
                }
                if (type == 'fpt') {
                    this.i_type = 0;
                    this.vc_type = '';
                    this.i_khtype = 0;
                    this.i_origin_khtype = 0;
                    this.vc_fymx = '';
                    this.i_issd = 0;
                    this.i_flag = 0;
                    this.f_sl = 0;
                    this.i_kpkhid = 0;
                    this.vc_kpkhname = '';
                    this.kpfData = [];
                }
                if (type == 'state') {
                    this.isover = null;
                    this.vc_isover = '';
                }
                if (type == 'kpf') {
                    this.i_kpkhid = 0;
                    this.vc_kpkhname = '';
                    this.vc_khcreditcode = '';
                    this.getkhlist('');
                }
                if (type == 'gs') {
                    this.companyId = 0;
                    this.companyName = "";
                    this.vc_gscreditcode = '';
                    this.lastCheckOutDate = '';
                }
                if (type == 'sou') {
                    this.vc_search = ""
                }
                if (type == 'xs') {
                    this.xsComId = 0;
                    this.xsComname = '';
                    this.vc_khcreditcode = '';
                }
                if (type == 'fplx') {
                    this.i_fptype = null;
                    this.vc_fptype = '';

                }
                if (type == 'code') {
                    this.vc_fkey = 0;
                }

            },
            // 小写金额转化为大写金额
            convertToChineseCapital(val) {
                let cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'] //汉字数字
                let cnIntRadice = ['', '拾', '佰', '仟']  //基本单位
                let cnIntUnits = ['元', '万', '亿', '兆'] //整数部分扩展单位
                let cnDecUnits = ['角', '分', '毫', '厘'] //小数部分扩展单位
                // let cnInteger = '整'
                let cnIntLast = '元'
                let integerNum  //金额的整数部分
                let decimalNum  //金额的小数部分
                let chineseStr = '' //输出的中文金额字符串
                let parts; //分离金额后用的数组
                if (val == '') {
                    return ''
                }
                if (val == 0) {
                    // return cnNums[0] + cnIntLast + cnInteger
                    return cnNums[0] + cnIntLast
                }
                // 转化为字符串
                val = val + ''
                if (val.indexOf('.') == -1) {
                    integerNum = val
                    decimalNum = ''
                } else {
                    parts = val.split('.')
                    integerNum = parts[0]
                    decimalNum = parts[1].substr(0, 4)
                }
                // 获取整形部分转化
                if (parseInt(integerNum, 10) > 0) {
                    let zeroCount = 0
                    let IntLen = integerNum.length
                    for (let i = 0; i < IntLen; i++) {
                        let n = integerNum.substr(i, 1)
                        let p = IntLen - i - 1
                        let q = p / 4
                        let m = p % 4
                        if (n == 0) {
                            zeroCount++
                        } else {
                            if (zeroCount > 0) {
                                chineseStr += cnNums[0]
                            }
                            // 归0
                            zeroCount = 0
                            chineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
                        }
                        if (m == 0 && zeroCount < 4) {
                            chineseStr += cnIntUnits[q]
                        }

                    }
                    // chineseStr += cnIntLast
                }
                // 小数部分
                if (decimalNum != '') {
                    let decLen = decimalNum.length
                    for (let i = 0; i < decLen; i++) {
                        let n = decimalNum.substr(i, 1)
                        if (n != 0) {
                            chineseStr += cnNums[Number(n)] + cnDecUnits[i]
                        }
                    }
                }
                if (chineseStr == '') {
                    // chineseStr += cnNums[0]+ cnIntLast + cnInteger
                    chineseStr += cnNums[0] + cnIntLast
                } else if (decimalNum == '') {
                    // chineseStr += cnInteger
                    chineseStr += ''
                }
                return chineseStr
            },

        },
    }
</script>


<style lang="scss" scoped>
    .Input{
        max-width: 220px;
        width: 100%;
    }
    /deep/.el-table td.is-right, .el-table th.is-right {
        text-align: right !important;
    }
    /deep/ .dis .el-loading-spinner .circular {
        display: none;
    }

    /deep/ .el-radio__original {
        display: none !important; /* 隐藏原生 radio 输入，但仍然允许交互 */
    }

    /deep/ .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
        box-shadow: none !important;
    }

    .pad10 {
        padding: 0 10px;
    }

    .fppm {
        width: 100%;
        max-height: 70px; /* 根据需要设置占位的行高 × 行数 */
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        display: -webkit-box;
        -webkit-line-clamp: 3; /* 显示的行数 */
        -webkit-box-orient: vertical;
    }

    .ale {
        align-items: end;
    }

    .img-box {
        margin: 0px;

        .uploadPhone {
            width: 70px;
            height: 80px;
            position: relative;
            width: 100%;
        }

        .uploadPhone img {
            width: 70px;
            height: 80px;
        }

        .upload-box {
            width: 30%;
            height: 30%;
        }

        .upload-input {
            position: absolute;
            opacity: 0;
            width: 70px;
            height: 80px;
        }
    }

    //弹窗窗口
    /deep/ .el-dialog__body {
        padding: 6px 10px !important;
    }

    .txtE {
        text-align: end;
    }

    .marl4 {
        margin-left: 4px;
    }

    /deep/ .red .el-input--mini .el-input__inner {
        color: #3e82e8 !important;
    }

    .red {
        color: #3e82e8 !important;
    }

    /*/deep/.el-table--scrollable-x .el-table__body-wrapper{
        height:195px !important;
    }*/
    .changeinput {
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        width: 120px;
    }
    .changeinput_mini {
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        width: 70px;
    }
    .changeinput3 {
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        width: 100px;
    }
    .el-icon-plus {
        font-size: 20px;
        color: #3e82e8;
        font-weight: bolder;
        background: #eef1f6;
    }

    .backgw {
        background: none !important;
    }

    .popaddbtn {
        border: none;
        padding: 0;
    }

    .pop .addbtn {
        border: none;
        padding: 0;
    }

    .w20 {
        width: 20%;
    }

    .blue {
        color: var(--dark) !important;
    }

    .tw11 {
        width: 11%;
    }

    .mart9 {
        margin-top: 9px;
    }

    .martb5 {
        margin: 5px 0px;
    }

    .txt {
        text-align: center;
    }

    .pad35_25 {
        padding: 35px 25px;
    }

    .padB5 {
        padding-bottom: 5px;
    }

    .marT10 {
        margin-top: 7px;
    }

    .pad15_25 {
        padding: 0px 25px;
    }

    .w100 {
        width: 100%;
    }

    .w33 {
        width: 33%;
    }

    .w50 {
        width: 50%;
    }

    .borderB {
        border-bottom: 1px solid #e1e1e1;
    }

    .border {
        border: 1px solid #e1e1e1;
        line-height: 24px;
        min-height: 24px;
    }

    .alc {
        align-items: center;
    }

    .font14_t {
        font-size: 16px;
        color: black;
        min-width: 90px;
        font-weight: 500;
    }

    .font14 {
        font-size: 14px;
        color: grey;
        min-width: 68px;
    }

    .box {
        width: 24px;
        height: 24px;
        line-height: 24px;
    }

    .boxyu {
        //background-color:var(--themeColor);
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }

    .flex_b {
        display: flex;
        justify-content: space-between;
    }
    .flex_e {
        display: flex;
        justify-content: end;
    }

    .flex {
        display: flex;
    }

    .fr {
        float: right;
    }

    .mrr9 {
        margin-right: 9px;
    }

    .padT6 {
        //padding: 6px 0;
    }

    .pad14 {
        padding: 3px 9px;
    }

    .w100 {
        width: 100%;
    }

    .marr4 {
        margin-right: 4px;
    }
</style>